import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoggerService } from '@commoncore/services/logger.service';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { ENV_CONFIG } from '@env-properties/environment-config';
import * as Bowser from "bowser";
import { LocalStorageSvc } from './localStorage.service';
import { SessionStorageService } from './session-storage.service';
import { ActiveRepo, UniversalService } from './universal.service';

@Injectable({
  providedIn: 'root'
})
export class ContextMenuMobileService {
  public mobileTopMenu:any;
  private favoriteMenu : any;
  private sharedByMe : any;
  private sharedWithMe : any;
  filesNotOwnedByUser:any =[];
  public iosChrome:boolean = false;
  officeForWeb: Object;
  userData:any ;

  constructor(public universalService:UniversalService,public router:Router,public loggerService:LoggerService,public http:HttpClient,private localStorageSvc:LocalStorageSvc,private sessionStorageService:SessionStorageService) {
    this.universalService.browserDetails = Bowser.parse(window.navigator.userAgent);
    //commented below check for the change to show 'Download' option in iOS chrome, ref. bug # 324670
    /*if(this.universalService.browserDetails.os.name == "iOS" && this.universalService.browserDetails.browser.name == "Chrome"){
      this.iosChrome = true;
    }else{
      this.iosChrome = false;
    }*/
   }

  removeAddtoJioCloud(){
    var classRef = this.universalService;
    let userData = this.localStorageSvc.getUserData(true);
    //if(this.router.url.indexOf("?u")>0 && this.localStorageSvc.getUserId(true) == this.localStorageSvc.getShareLinkCreator() ){
    if(userData && this.router.url.indexOf("?u")>0 && userData["userId"] == this.sessionStorageService.getShareLinkCreator() ){
      // remove add to jiocloud option
      var topfound = classRef.topMenuOptions.find(k => k["onClick"] == "addToJioCloud")
      if(topfound){
        var index = classRef.topMenuOptions.indexOf(topfound)
        classRef.topMenuOptions.splice(index,1)
      }
    }

   }
  async decideContextMenuItemsForMobile(){
    var classRef = this.universalService;
    this.userData = this.localStorageSvc.getUserData(true);
    if(classRef.activeRepo == ActiveRepo.SHARE){
      classRef.isFolderPresent();

      if(classRef.mobileSelectionModeOn){ // mobile selection mode is on
        if(classRef.selectedNodes.length == 0){ // no files are selected
          classRef.topMenuOptions = classRef.topMenuMobile_Share["selectionModeOn"]["files_Not_Selected"]["topMenu"];
          this.removeAddtoJioCloud()
        }else if(classRef.selectedNodes.length == 1){  // only 1 file is selected
          var file = classRef.selectedNodes[0]
          if(classRef.showAddToJioCloudOnTopMenu){ // if it is not folder but it is a file
            this.getSingleFileContextMenu_Share(file,classRef.mobileSelectionModeOn);
          }else{ // if it is folder 
            this.getSingleFolderContextMenu_Share(classRef.mobileSelectionModeOn);
          }
        }else{ // multiple files are selected
          if(classRef.showAddToJioCloudOnTopMenu){ // if it is not folder and only files are selected
            this.getMultipleFileContextMenu_Share(classRef.mobileSelectionModeOn);
          }else{ // if it is folder 
            this.getMultipleFolderContextMenu_Share(classRef.mobileSelectionModeOn);
          }
        }
      }else{ // mobile selection mode is off
        if(classRef.selectedNodes.length == 1){ 
          var file = classRef.selectedNodes[0]
          if(classRef.showAddToJioCloudOnTopMenu){ // if it is not folder but it is a file
            this.getSingleFileContextMenu_Share(file,classRef.mobileSelectionModeOn);
          }else{ // if it is folder 
            this.getSingleFolderContextMenu_Share(classRef.mobileSelectionModeOn);
          }
          this.getDefaultIconContentForObjects();
        }else{
          this.loggerService.log("inside selection mode of and selected files are > 1 ")
        }
      }
    }else if(classRef.activeRepo == ActiveRepo.MAIN){
      if(this.router.url.includes("/memory")){
        this.getContextMenuOptionsForMemory();
        return
      }
      classRef.isFolderPresent(); // check if selection includes folders
      if(classRef.mobileSelectionModeOn){ // selection mode is on
        if(classRef.selectedNodes.length == 1){ // if single file is selected
          var file = classRef.selectedNodes[0]
          classRef.selectedFile = classRef.selectedNodes[0];
          if(classRef.showAddToJioCloudOnTopMenu){ // if it is not folder but it is a file
            let previewFromUpload = file["previewFromUpload"];
            if(!previewFromUpload && this.router.url.includes('/digilocker')){
              this.getDigiLockerContextMenuMobile(classRef.mobileSelectionModeOn);
            }else if(!previewFromUpload && this.router.url.includes('/jpai')){
              this.getContextMenuForSingleFileJioPhoneCallAI(classRef.mobileSelectionModeOn);
            }else if(!previewFromUpload && this.router.url.includes('trash')){
              this.getContextMenuForTrashFiles();
            }else if ((!previewFromUpload && this.router.url.includes('/shared/')) || (previewFromUpload && file["uploadInitiatedModule"] == "sharedFiles")){
              this.getContextMenuForSingleSharedFile(file,classRef.mobileSelectionModeOn);
            }else{
              this.getContextMenuForSingleFileOrAlbum(file,classRef.mobileSelectionModeOn);
            }
            this.checkIfManageVersionsIsTobeSupported(file);
            if(!this.router.url.includes('trash')){
              this.checkIfOpenWithOfficeForWebOption(file);
              this.addEditImageOptionIfImageFileIsSelected(file);
            }
            this.checkIfUploafFromPreviewAndRemoveUnecessaryOptions(file,this.universalService.topMenuOptions,this.universalService.middleMenuOptionsMobile,this.universalService.bottomMenuOptionsMobile)
          }else{ // if it is  folder but not a file
            if(this.router.url.includes('/digilocker')){
              this.getDigiLockerContextMenuMobile(classRef.mobileSelectionModeOn);
            }else if(this.router.url.includes('/jpai')){
              this.getContextMenuForSingleFolderJioPhoneCallAI(classRef.mobileSelectionModeOn);
            }else if(this.router.url.includes('trash')){
              this.getContextMenuForTrashFiles();
            }else if (this.router.url.includes('/shared/')){
              this.getContextMenuForSingleSharedFile(file,classRef.mobileSelectionModeOn);
            } else if (this.router.url.includes('/teamfolders/') || this.router.url.includes('/search/tf')){
              this.getContextMenuForInsideTeamFolders(classRef.mobileSelectionModeOn, file);
            }else if (this.router.url.includes('/privatefolder')){
              this.getContextMenuForInsidePrivateFolder(classRef.mobileSelectionModeOn, file);
            } 
            else{
              this.getSingleFolderContextMenu(classRef.mobileSelectionModeOn);
            }
            this.removeDownloadOptionFromMenuWhenTheObjectsAreFromDifferentHierarchies();
            if(classRef.selectedNodes.length > 1)
              this.removeShareOptionFromMenuWhenMultipleObject();
      
          }
        }else{ // if multiple files are selected
          if(classRef.showAddToJioCloudOnTopMenu){ // has only files
            if(this.router.url.includes('/digilocker')){
              this.getDigiLockerMultipleFileContextMenuMobile();
            }else if(this.router.url.includes('/jpai')){
              this.getContextMenuForMultipleFilesJioPhoneCallAI(classRef.mobileSelectionModeOn);
            }else if(this.router.url.includes('trash')){
              this.getContextMenuForTrashFiles();
            }else if (this.router.url.includes('/shared/')){
              this.getContextMenuForMultipleSharedFiles(classRef.mobileSelectionModeOn);
            }else{
            this.getContextMenuForMultipleFilesOrAlbums();
            }
          }else{ // includes folders also
            if(this.router.url.includes('trash')){
              this.getContextMenuForTrashFiles();
            }else if(this.router.url.includes('/jpai')){
              this.getContextMenuForMultipleFoldersJioPhoneCallAI(classRef.mobileSelectionModeOn);
            }else if (this.router.url.includes('/shared/')){
              this.getContextMenuForMultipleSharedFiles(classRef.mobileSelectionModeOn);
            } else if (this.router.url.includes('/teamfolders/') || this.router.url.includes('/search/tf')){
              var file = classRef.selectedNodes[0];
              this.getMultipleFolderContextMenuForTeamFolder(file);  
            } else if (this.router.url.includes('/privatefolder')){
              this.getMultipleFolderContextMenuForPrivateFolder();  
            }else{
            this.getMultipleFolderContextMenu();
            }
            this.removeDownloadOptionFromMenuWhenTheObjectsAreFromDifferentHierarchies();
            if(classRef.selectedNodes.length > 1)
              this.removeShareOptionFromMenuWhenMultipleObject();
      
          }
        }
      } else{ // selection mode is off
        if(classRef.selectedNodes.length == 1){ // only 1 item is selected
          var file = classRef.selectedNodes[0]
          let previewFromUpload = file["previewFromUpload"]
          if(!previewFromUpload && this.universalService.isUserOnSharedLinkByMe) {
            this.getContextMenuForSharedLinkByMe();
          } else if(classRef.showAddToJioCloudOnTopMenu){ // includes only file
            if(!previewFromUpload && this.router.url.includes('/digilocker')){
              this.getDigiLockerContextMenuMobile(classRef.mobileSelectionModeOn);
            }else if(!previewFromUpload && this.router.url.includes('/jpai')){
              this.getContextMenuForSingleFileJioPhoneCallAI(classRef.mobileSelectionModeOn);
            }else if(!previewFromUpload && this.router.url.includes('trash')){
              this.getContextMenuForTrashFiles();
            }else if((!previewFromUpload && this.router.url.includes('/shared/')) || (previewFromUpload && file["uploadInitiatedModule"] == "sharedFiles")){
              this.getContextMenuForSingleSharedFile(file,classRef.mobileSelectionModeOn);
            }else{
              this.getContextMenuForSingleFileOrAlbum(file,classRef.mobileSelectionModeOn);
            }
            this.checkIfManageVersionsIsTobeSupported(file);
            if(!this.router.url.includes('trash')){
              this.checkIfOpenWithOfficeForWebOption(file);
              this.addEditImageOptionIfImageFileIsSelected(file);
            }
            this.checkIfUploafFromPreviewAndRemoveUnecessaryOptions(file,this.universalService.topMenuOptions,this.universalService.middleMenuOptionsMobile,this.universalService.bottomMenuOptionsMobile)
          }else{ // includes folders
            if(this.router.url.includes('trash')){
              this.getContextMenuForTrashFiles();
            }else if(this.router.url.includes('/jpai')){
              this.getContextMenuForSingleFolderJioPhoneCallAI(classRef.mobileSelectionModeOn);
            }else if (this.router.url.includes('/shared/')){
              this.getContextMenuForSingleSharedFile(file,classRef.mobileSelectionModeOn);
            }else if (this.router.url.includes('/teamfolders') && !this.router.url.includes('/teamfolders/')){
              this.getContextMenuForTeamFolders(file);
            }else if (this.router.url.includes('/teamfolders/') || this.router.url.includes('/search/tf')){
              this.getContextMenuForInsideTeamFolders(classRef.mobileSelectionModeOn, file);
            }else if (this.router.url.includes('/privatefolder')){
              this.getContextMenuForInsidePrivateFolder(classRef.mobileSelectionModeOn, file);
            }
            else{
            this.getSingleFolderContextMenu(classRef.mobileSelectionModeOn);
            }
            this.removeDownloadOptionFromMenuWhenTheObjectsAreFromDifferentHierarchies();
          }
          this.getDefaultIconContentForObjects();
        }else{ // if more than one file is selected and selection mode is off
          this.loggerService.log("inside selection mode of and selected files are > 1 ")
        }
        this.checkIfPrivateFolderOptionToShow();
      }
      this.checkIfShowLocationOption();
    }else if(classRef.activeRepo == ActiveRepo.INVITE){
      if(classRef.mobileSelectionModeOn){ // selection mode is on
        if(classRef.selectedNodes.length == 1){ // if single file is selected
          var file = classRef.selectedNodes[0]
          classRef.selectedFile = classRef.selectedNodes[0];
          if(classRef.showAddToJioCloudOnTopMenu){ // if it is not folder but it is a file
            this.getContextMenuForSingleFileOrAlbum(file,classRef.mobileSelectionModeOn);
            this.checkIfManageVersionsIsTobeSupported(file);
            this.checkIfUploafFromPreviewAndRemoveUnecessaryOptions(file,this.universalService.topMenuOptions,this.universalService.middleMenuOptionsMobile,this.universalService.bottomMenuOptionsMobile)
          }
        }else{ // if multiple files are selected
          if(classRef.showAddToJioCloudOnTopMenu){ // has only files
            this.getContextMenuForMultipleFilesOrAlbums();
          }
        }
      } else{ // selection mode is off
        if(classRef.selectedNodes.length == 1){ // only 1 item is selected
          classRef.selectedFile = classRef.selectedNodes[0];
          var file = classRef.selectedNodes[0];
          if(classRef.showAddToJioCloudOnTopMenu){ // includes only file
            this.getContextMenuForSingleFileOrAlbum(file,classRef.mobileSelectionModeOn);
          }
          this.getDefaultIconContentForObjects();
        }else{ // if more than one file is selected and selection mode is off
          this.loggerService.log("inside selection mode of and selected files are > 1 ")
        }
      }
    }
    this.loggerService.log("top menu options for mobile are ==>>",this.universalService.topMenuOptions)
    this.loggerService.log("middle menu options for mobile are ==>>",this.universalService.middleMenuOptionsMobile)
    this.loggerService.log("bottom menu options for mobile are ==>>",this.universalService.bottomMenuOptionsMobile)
  }

  getDigiLockerContextMenuMobile(selectionMode){
    let classRef = this.universalService;
    if(selectionMode){ // selection mode is on
      if(classRef.openMoreOptions){ // if more options is open
        classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["digiMenu"]["inExpandMode"]["topMenu"];
        classRef.middleMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["digiMenu"]["inExpandMode"]["middleMenu"];
        classRef.bottomMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["digiMenu"]["inExpandMode"]["bottomMenu"];
      }else{ // if more options is close
        classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["singleFile"]["digiMenu"]["topMenu"];
        classRef.middleMenuOptionsMobile = [];
        classRef.bottomMenuOptionsMobile = [];
      }
    }else{ //selection mode if Off
      if(classRef.showPreview == true){ // preview is true
          if(classRef.openMoreOptions){ // if more options is open
            classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["digiMenu"]["inExpandMode"]["topMenu"];
            classRef.middleMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["digiMenu"]["inExpandMode"]["middleMenu"];
            classRef.bottomMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["digiMenu"]["inExpandMode"]["bottomMenu"];
          }else{ // if more options is closed
            // classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["fileMenu"]["topMenu"]
            classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["singleFile"]["digiMenu"]["topMenu"];
            classRef.middleMenuOptionsMobile = []
            classRef.bottomMenuOptionsMobile = []
          }
      }else{
        classRef.topMenuOptions  = [];
        classRef.middleMenuOptionsMobile = [];
        classRef.bottomMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOff"]["digiMenu"]["bottomMenu"]
      }
    }
    this.getDefaultIconContentForObjects();
  }

  getDigiLockerMultipleFileContextMenuMobile(){
    let classRef = this.universalService;
    if(classRef.openMoreOptions){ // if more options is open
      classRef.topMenuOptions  = classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["digiMenu"]["inExpandMode"]["topMenu"];
      classRef.middleMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["digiMenu"]["inExpandMode"]["middleMenu"];
      classRef.bottomMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["digiMenu"]["inExpandMode"]["bottomMenu"];
    }else{ // if more options is closed
      classRef.topMenuOptions  = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["multipleFile"]["digiMenu"]["topMenu"];
      classRef.middleMenuOptionsMobile = [];
      classRef.bottomMenuOptionsMobile = [];
    }
      this.removePrivateFolderOption();
  }

  getContextMenuForSingleFileOrAlbum(file,mobSelectionMode){ 
    if(this.universalService.activeRepo == ActiveRepo.INVITE){
      this.getContextMenuForSingleAlbumFile(mobSelectionMode)
      return
   }
    let previewFromUpload = file["previewFromUpload"] 
    if(file["objectType"] == "FE"){  // if single file is selected
      this.getSingleFileContextMenu(mobSelectionMode);
    }else{ // if a album file is selected
      if((!previewFromUpload && this.router.url.includes('/favorites/'))){
        this.getContextMenuForFavoritesTabSingleAlbumFile(mobSelectionMode);
      }else{
        // single album file and not on favorites tab
        this.universalService.fetchJSONContent();
        this.getContextMenuForSingleAlbumFile(mobSelectionMode)
      }
    }
  }


  getContextMenuForMultipleFilesOrAlbums(){
    if(this.universalService.activeRepo == 'invite'){
      this.getMultipleFileContextMenu()
      return;
    }
    var albumFiles = this.checkAlbumFilesStatus();
    if(albumFiles.length > 0 ){ // the files selected are album files
      if(this.router.url.includes('/favorites/')){
        this.getContextMenuForFavoritesTabMultipleAlbumFile();
      }else{
        // multiple album file and not on favorites tab
        this.getContextMenuForMultipleAlbumFiles();
      }
    }else{ // the files selected are not album files
    this.getMultipleFileContextMenu();
    }
  }
  
  

  getSingleFolderContextMenu_Share(selectionMode){
    var classRef = this.universalService;
    var self = this;
    if(selectionMode){
      classRef.topMenuOptions  = self.iosChrome ? classRef.topMenuMobile_Share["selectionModeOn"]["singleFile"]["folderMenu_IosChrome"]["topMenu"] :classRef.topMenuMobile_Share["selectionModeOn"]["singleFile"]["folderMenu"]["topMenu"]
    }else{
      classRef.topMenuOptions  = self.iosChrome ? classRef.topMenuMobile_Share["selectionModeOff"]["folderMenu_IosChrome"]["topMenu"] : classRef.topMenuMobile_Share["selectionModeOff"]["folderMenu"]["topMenu"]
    }
  }


  getSingleFolderContextMenu(selectionMode){  // if it is a folder
    var classRef = this.universalService;
    if(this.router.url.includes('/digilocker')){
      this.getDigiLockerContextMenuMobile(selectionMode);
      return
    }
    var isFavorite;  
    isFavorite = this.checkFavoriteStatus();
    if(selectionMode){ // if selection mode is on
      if(classRef.openMoreOptions){ // if the menu is expanded form
        classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["folderMenu"]["inExpandMode"]["topMenu"]
        classRef.middleMenuOptionsMobile = isFavorite?classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["folderMenu"]["inExpandMode"]["middleMenu"]["unSetFavorite"]:classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["folderMenu"]["inExpandMode"]["middleMenu"]["setFavorite"]
        classRef.bottomMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["folderMenu"]["inExpandMode"]["bottomMenu"]
      }else{ // if the menu is collapsed form
        // classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["folderMenu"]["topMenu"]
        classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["singleFile"]["folderMenu"]["topMenu"]
        classRef.middleMenuOptionsMobile = []
        classRef.bottomMenuOptionsMobile = []
      }
    }else{
      classRef.topMenuOptions  = [];
      let menu = classRef.topMenuMobile_MainRepo["selectionModeOff"];
      classRef.middleMenuOptionsMobile = menu["folderMenu"]["middleMenu"];
      classRef.bottomMenuOptionsMobile = menu["folderMenu"]["bottomMenu"]
    }
    this.removePrivateFolderOption();
    
  }


  getSingleFileContextMenu_Share(file,selectionMode){
    var classRef = this.universalService;
    var self = this;
    if(selectionMode){
      classRef.topMenuOptions  = self.iosChrome ? classRef.topMenuMobile_Share["selectionModeOn"]["singleFile"]["fileMenu_IosChrome"]["topMenu"] : classRef.topMenuMobile_Share["selectionModeOn"]["singleFile"]["fileMenu"]["topMenu"]
    }else{
      if(classRef.showPreview == true){
        if(window.location.href.includes('?u')){
          //classRef.topMenuOptions  = self.iosChrome ? classRef.topMenuMobile_Share["selectionModeOff"]["preview_FileMenu_IosChrome"]["topMenu"] : classRef.topMenuMobile_Share["selectionModeOff"]["preview_FileMenu"]["topMenu"] 
          classRef.topMenuOptions  = classRef.topMenuMobile_Share["selectionModeOff"]["preview_FileMenu"]["topMenu"];
        }else{
          if(file["mimeType"] == 'image' || file["mimeType"] == 'video'){
            classRef.topMenuOptions  = self.iosChrome ? classRef.topMenuMobile_Share["selectionModeOff"]["preview_Image_FileMenu_IosChrome"]["topMenu"] : classRef.topMenuMobile_Share["selectionModeOff"]["preview_Image_FileMenu"]["topMenu"] 
          }else{
            classRef.topMenuOptions  = self.iosChrome ? classRef.topMenuMobile_Share["selectionModeOff"]["preview_Other_FileMenu_IosChrome"]["topMenu"] : classRef.topMenuMobile_Share["selectionModeOff"]["preview_Other_FileMenu"]["topMenu"] 
          }
        }
      }else{
        classRef.topMenuOptions  = self.iosChrome ? classRef.topMenuMobile_Share["selectionModeOff"]["fileMenu_IosChrome"]["topMenu"] : classRef.topMenuMobile_Share["selectionModeOff"]["fileMenu"]["topMenu"]
      }
    }
    this.removeAddtoJioCloud()
  }

  getSingleFileContextMenu(selectionMode){
    // if it is a file 
    var isFavorite;  
    var showAddToAlbumOption = this.universalService.checkIfImageAndVideosExistInSelection();
    isFavorite = this.checkFavoriteStatus();
    var classRef = this.universalService;
    let file = classRef.selectedNodes[0];
    let previewFromUpload = file["previewFromUpload"]
    if(classRef.currentTab == "Person Details" && !previewFromUpload){
      this.getSingleFileContextMenuForPeople(selectionMode)
      return
    }else if(classRef.currentTab == "Place Details" && !previewFromUpload){
      this.getSingleFileContextMenuForPlace(selectionMode)
      return
    } else if ((!previewFromUpload && this.router.url.includes('/teamfolders/')) || (!previewFromUpload && this.router.url.includes('/search/tf/')) || (previewFromUpload && file["uploadInitiatedModule"] == "teamfolders")){
      this.getSingleFileContextMenuForTeamFolder(selectionMode);
      return;
    } else if ((!previewFromUpload && this.router.url.includes('/privatefolder')) || (previewFromUpload && file["uploadInitiatedModule"] == "PrivateFolder")){
      this.getSingleFileContextMenuForPrivateFolder(selectionMode)
      return;
    }
    if(selectionMode){ // selection mode is on
      if(classRef.openMoreOptions){ // if more options is open
        classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["fileMenu"]["inExpandMode"]["topMenu"]
        classRef.middleMenuOptionsMobile = isFavorite?classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["fileMenu"]["inExpandMode"]["middleMenu"]["unSetFavorite"]:classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["fileMenu"]["inExpandMode"]["middleMenu"]["setFavorite"]
        classRef.bottomMenuOptionsMobile = showAddToAlbumOption ? classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["fileMenu"]["inExpandMode"]["bottomMenu"] : classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["fileMenu"]["inExpandMode"]["bottomMenu_Other_Than_Images_And_Videos"]
      }else{ // if more options is close
        classRef.topMenuOptions = showAddToAlbumOption ? classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["singleFile"]["fileMenu"]["topMenu"] : classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["singleFile"]["fileMenu"]["topMenu_Other_Than_Images_And_Videos"];
        classRef.middleMenuOptionsMobile = []
        classRef.bottomMenuOptionsMobile = []
      }
    }else{ //selection mode if Off
      if(classRef.showPreview == true){ // preview is true
          if(classRef.openMoreOptions){ // if more options is open
            classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["fileMenu"]["inExpandMode"]["topMenu"]
            classRef.middleMenuOptionsMobile = isFavorite?classRef.topMenuMobile_MainRepo["selectionModeOff"]["fileMenu"]["middleMenu"]["unSetFavorite"]:classRef.topMenuMobile_MainRepo["selectionModeOff"]["fileMenu"]["middleMenu"]["setFavorite"]
            classRef.bottomMenuOptionsMobile = showAddToAlbumOption ? classRef.topMenuMobile_MainRepo["selectionModeOff"]["fileMenu"]["preview_bottomMenu"] : classRef.topMenuMobile_MainRepo["selectionModeOff"]["fileMenu"]["preview_bottomMenu_Other_Than_Images_And_Videos"]
          }else{ // if more options is closed
            // classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["fileMenu"]["topMenu"]
            classRef.topMenuOptions = showAddToAlbumOption ? classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["singleFile"]["fileMenu"]["topMenu"] : classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["singleFile"]["fileMenu"]["topMenu_Other_Than_Images_And_Videos"]
            classRef.middleMenuOptionsMobile = []
            classRef.bottomMenuOptionsMobile = []
          }
      }else{
        classRef.topMenuOptions  = [];
        classRef.middleMenuOptionsMobile = isFavorite?classRef.topMenuMobile_MainRepo["selectionModeOff"]["fileMenu"]["middleMenu"]["unSetFavorite"]:classRef.topMenuMobile_MainRepo["selectionModeOff"]["fileMenu"]["middleMenu"]["setFavorite"];
        classRef.bottomMenuOptionsMobile = showAddToAlbumOption ? classRef.topMenuMobile_MainRepo["selectionModeOff"]["fileMenu"]["bottomMenu"] : classRef.topMenuMobile_MainRepo["selectionModeOff"]["fileMenu"]["bottomMenu_Other_Than_Images_And_Videos"]
      }
    }
      this.removePrivateFolderOption();
  }

  getSingleFileContextMenuForTeamFolder(selectionMode) {          
    var classRef = this.universalService;
    var file = classRef.selectedNodes[0];
    var roleCode = this.getTFRoleCodeDetail(file["roleCode"]);
    
    if(selectionMode){ // selection mode is on
      if(classRef.openMoreOptions){ // if more options is open
        classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["fileMenu"]["inExpandMode"]["insideTeamFolders"][roleCode]["topMenu"]
        //classRef.middleMenuOptionsMobile = isFavorite?classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["fileMenu"]["inExpandMode"]["middleMenu"]["unSetFavorite"]:classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["fileMenu"]["inExpandMode"]["middleMenu"]["setFavorite"]
        classRef.bottomMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["fileMenu"]["inExpandMode"]["insideTeamFolders"][roleCode]["bottomMenu"]
      }else{ // if more options is close
        classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["singleFile"]["insideTeamFolders"][roleCode]["topMenu"];
        classRef.middleMenuOptionsMobile = []
        classRef.bottomMenuOptionsMobile = []
      }
    }else{ //selection mode if Off
      if(classRef.showPreview == true){ // preview is true
          if(classRef.openMoreOptions){ // if more options is open
            classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["fileMenu"]["inExpandMode"]["insideTeamFolders"][roleCode]["topMenu"]
            //classRef.middleMenuOptionsMobile = isFavorite?classRef.topMenuMobile_MainRepo["selectionModeOff"]["fileMenu"]["middleMenu"]["unSetFavorite"]:classRef.topMenuMobile_MainRepo["selectionModeOff"]["fileMenu"]["middleMenu"]["setFavorite"]
            classRef.bottomMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOff"]["fileMenu"]["insideTeamFolders"][roleCode]["preview_bottomMenu"]
          }else{ // if more options is closed
            // classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["fileMenu"]["topMenu"]
            classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["singleFile"]["insideTeamFolders"][roleCode]["topMenu"];
            classRef.middleMenuOptionsMobile = []
            classRef.bottomMenuOptionsMobile = []
          }
      }else{
        classRef.topMenuOptions  = [];
        classRef.bottomMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOff"]["fileMenu"]["insideTeamFolders"][roleCode]["bottomMenu"]
      }
    }
  }
  getSingleFileContextMenuForPrivateFolder(selectionMode) {          
    var classRef = this.universalService;
    var file = classRef.selectedNodes[0];
    
    if(selectionMode){ // selection mode is on
      if(classRef.openMoreOptions){ // if more options is open
        classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["fileMenu"]["inExpandMode"]["insidePrivateFolder"]["topMenu"]
        //classRef.middleMenuOptionsMobile = isFavorite?classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["fileMenu"]["inExpandMode"]["middleMenu"]["unSetFavorite"]:classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["fileMenu"]["inExpandMode"]["middleMenu"]["setFavorite"]
        classRef.bottomMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["fileMenu"]["inExpandMode"]["insidePrivateFolder"]["bottomMenu"]
      }else{ // if more options is close
        classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["singleFile"]["insidePrivateFolder"]["topMenu"];
        classRef.middleMenuOptionsMobile = []
        classRef.bottomMenuOptionsMobile = []
      }
    }else{ //selection mode if Off
      if(classRef.showPreview == true){ // preview is true
          if(classRef.openMoreOptions){ // if more options is open
            classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["fileMenu"]["inExpandMode"]["insidePrivateFolder"]["topMenu"]
            //classRef.middleMenuOptionsMobile = isFavorite?classRef.topMenuMobile_MainRepo["selectionModeOff"]["fileMenu"]["middleMenu"]["unSetFavorite"]:classRef.topMenuMobile_MainRepo["selectionModeOff"]["fileMenu"]["middleMenu"]["setFavorite"]
            classRef.bottomMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOff"]["fileMenu"]["insidePrivateFolder"]["preview_bottomMenu"]
          }else{ // if more options is closed
            // classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["fileMenu"]["topMenu"]
            // classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["insidePrivateFolder"]["fileMenu"]["topMenu"]
            classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["singleFile"]["insidePrivateFolder"]["topMenu"];
            classRef.middleMenuOptionsMobile = []
            classRef.bottomMenuOptionsMobile = []
          }
      }else{
        classRef.topMenuOptions  = [];
        classRef.bottomMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOff"]["fileMenu"]["insidePrivateFolder"]["bottomMenu"]
      }
    }
  }

  
  getSingleFileContextMenuForPeople(selectionMode){  // if it is a file 
    var isFavorite;  
    isFavorite = this.checkFavoriteStatus();
    var classRef = this.universalService;
    if(selectionMode){ // selection mode is on
      if(classRef.openMoreOptions){ // if more options is open
        classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["peopleTab"]["inExpandMode"]["topMenu"]
        classRef.middleMenuOptionsMobile = isFavorite?classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["peopleTab"]["inExpandMode"]["middleMenu"]["unSetFavorite"]:classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["fileMenu"]["inExpandMode"]["middleMenu"]["setFavorite"]
        classRef.bottomMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["peopleTab"]["inExpandMode"]["bottomMenu"]
      }else{ // if more options is close
        classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["singleFile"]["peopleTab"]["topMenu"];
        classRef.middleMenuOptionsMobile = []
        classRef.bottomMenuOptionsMobile = []
      }
    }else{ //selection mode if Off
      if(classRef.showPreview == true){ // preview is true
          if(classRef.openMoreOptions){ // if more options is open
            classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["peopleTab"]["inExpandMode"]["topMenu"]
            classRef.middleMenuOptionsMobile = isFavorite?classRef.topMenuMobile_MainRepo["selectionModeOff"]["peopleTab"]["middleMenu"]["unSetFavorite"]:classRef.topMenuMobile_MainRepo["selectionModeOff"]["fileMenu"]["middleMenu"]["setFavorite"]
            classRef.bottomMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOff"]["peopleTab"]["preview_bottomMenu"]
          }else{ // if more options is closed
            // classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["fileMenu"]["topMenu"]
            classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["singleFile"]["peopleTab"]["topMenu"]
            classRef.middleMenuOptionsMobile = []
            classRef.bottomMenuOptionsMobile = []
          }
      }else{
        classRef.topMenuOptions  = [];
        classRef.middleMenuOptionsMobile = isFavorite?classRef.topMenuMobile_MainRepo["selectionModeOff"]["peopleTab"]["middleMenu"]["unSetFavorite"]:classRef.topMenuMobile_MainRepo["selectionModeOff"]["fileMenu"]["middleMenu"]["setFavorite"];
        classRef.bottomMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOff"]["peopleTab"]["bottomMenu"]
      }
    }
  }

  getSingleFileContextMenuForPlace(selectionMode){  // if it is a file 
    var isFavorite;  
    isFavorite = this.checkFavoriteStatus();
    var classRef = this.universalService;
    if(selectionMode){ // selection mode is on
      if(classRef.openMoreOptions){ // if more options is open
        classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["placeTab"]["inExpandMode"]["topMenu"]
        classRef.middleMenuOptionsMobile = isFavorite?classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["placeTab"]["inExpandMode"]["middleMenu"]["unSetFavorite"]:classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["fileMenu"]["inExpandMode"]["middleMenu"]["setFavorite"]
        classRef.bottomMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["placeTab"]["inExpandMode"]["bottomMenu"]
      }else{ // if more options is close
        classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["singleFile"]["placeTab"]["topMenu"];
        classRef.middleMenuOptionsMobile = []
        classRef.bottomMenuOptionsMobile = []
      }
    }else{ //selection mode if Off
      if(classRef.showPreview == true){ // preview is true
          if(classRef.openMoreOptions){ // if more options is open
            classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["placeTab"]["inExpandMode"]["topMenu"]
            classRef.middleMenuOptionsMobile = isFavorite?classRef.topMenuMobile_MainRepo["selectionModeOff"]["placeTab"]["middleMenu"]["unSetFavorite"]:classRef.topMenuMobile_MainRepo["selectionModeOff"]["fileMenu"]["middleMenu"]["setFavorite"]
            classRef.bottomMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOff"]["placeTab"]["preview_bottomMenu"]
          }else{ // if more options is closed
            // classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["fileMenu"]["topMenu"]
            classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["singleFile"]["placeTab"]["topMenu"]
            classRef.middleMenuOptionsMobile = []
            classRef.bottomMenuOptionsMobile = []
          }
      }else{
        classRef.topMenuOptions  = [];
        classRef.middleMenuOptionsMobile = isFavorite?classRef.topMenuMobile_MainRepo["selectionModeOff"]["placeTab"]["middleMenu"]["unSetFavorite"]:classRef.topMenuMobile_MainRepo["selectionModeOff"]["fileMenu"]["middleMenu"]["setFavorite"];
        classRef.bottomMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOff"]["placeTab"]["bottomMenu"]
      }
    }
  }
  async getContextMenuForFavoritesTabSingleAlbumFile(selectionMode){
    var classRef = this.universalService;
    await this.findFileOwner();
    var iosDevice = this.checkIfIosDevice()
    if(selectionMode){ // selection mode is on
      if (classRef.openMoreOptions) { // more options is open
        classRef.topMenuOptions = this.favoriteMenu["selectionModeOn"]["singleFile"]["inExpandMode"]["topMenu"];
        classRef.middleMenuOptionsMobile = this.favoriteMenu["selectionModeOn"]["singleFile"]["inExpandMode"]["middleMenu"]["unSetFavorite"];
        classRef.bottomMenuOptionsMobile = this.favoriteMenu["selectionModeOn"]["singleFile"]["inExpandMode"]["bottomMenu"];
        if (this.filesNotOwnedByUser.length == classRef.selectedNodes.length) {
          classRef.bottomMenuOptionsMobile = this.favoriteMenu["selectionModeOn"]["singleFile"]["inExpandMode"]["bottomMenu"];
        } else {
          classRef.bottomMenuOptionsMobile = this.favoriteMenu["selectionModeOn"]["singleFile"]["inExpandMode"]["bottomMenu_Owner"];
        }
      } else { // more options is closed
        classRef.topMenuOptions = this.favoriteMenu["selectionModeOn"]["collapsedMode"]["topMenu"];
        classRef.middleMenuOptionsMobile = [];
        classRef.bottomMenuOptionsMobile = [];
      }
      
    } else{
       if(classRef.showPreview){ // if preview is open
        if(classRef.openMoreOptions){ // if more options is open
          classRef.topMenuOptions = this.favoriteMenu["selectionModeOn"]["singleFile"]["inExpandMode"]["topMenu"]
          classRef.middleMenuOptionsMobile = this.favoriteMenu["selectionModeOn"]["singleFile"]["inExpandMode"]["middleMenu"]["unSetFavorite"];
          if(this.filesNotOwnedByUser.length == classRef.selectedNodes.length){
            classRef.bottomMenuOptionsMobile = this.favoriteMenu["selectionModeOn"]["singleFile"]["inExpandMode"]["bottomMenu"];
          } else {
            classRef.bottomMenuOptionsMobile = this.favoriteMenu["selectionModeOn"]["singleFile"]["inExpandMode"]["bottomMenu_Owner"];
          }
        }else{ // if more options is closed
          classRef.topMenuOptions = this.favoriteMenu["selectionModeOn"]["collapsedMode"]["topMenu"]
          classRef.middleMenuOptionsMobile = []
          classRef.bottomMenuOptionsMobile = []
        }
      }else{
        classRef.topMenuOptions = [];
        this.getDefaultIconContentForObjects();
        classRef.middleMenuOptionsMobile = this.favoriteMenu["selectionModeOff"]["middleMenu"]["unSetFavorite"];
        if(this.filesNotOwnedByUser.length == classRef.selectedNodes.length){
          classRef.bottomMenuOptionsMobile = this.favoriteMenu["selectionModeOff"]["bottomMenu"];
        } else {
          classRef.bottomMenuOptionsMobile = this.favoriteMenu["selectionModeOff"]["bottomMenu_Owner"];
        }
      }
    }
  }

  getContextMenuForSingleAlbumFile(selectionMode){
    var classRef = this.universalService;
    var isFavorite,iosDevice,showCoverPhotoOption;  
    isFavorite = this.checkFavoriteStatus();
    iosDevice = this.checkIfIosDevice();
    showCoverPhotoOption = this.checkIfSetCoverPhotoShouldBeShown(classRef.selectedNodes[0])
    var file = classRef.selectedNodes[0];
    if(this.universalService.activeRepo == ActiveRepo.INVITE){
      if(selectionMode){
        classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["albumInvite"]["topMenu"];
      }else{
        classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOff"]["albumInvite"]["topMenu"];
      }
      return
   }
    if(selectionMode){
      if(file["isLoggedInUsrAlbumOwner"] || (file["isLoggedInUsrAlbumOwner"] == false && file["isLoggedInUsrFileOwner"] == true)){
        if(classRef.openMoreOptions){
            classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["albumMenu"]["inExpandMode"]["topMenu"];
            classRef.middleMenuOptionsMobile = isFavorite?classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["albumMenu"]["inExpandMode"]["middleMenu"]["unSetFavorite"]:classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["albumMenu"]["inExpandMode"]["middleMenu"]["setFavorite"]
            classRef.bottomMenuOptionsMobile = showCoverPhotoOption?classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["albumMenu"]["inExpandMode"]["bottomMenu"]["coverPhotoMenu"]:classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["albumMenu"]["inExpandMode"]["bottomMenu"]["NoncoverPhotoMenu"];
        }else{ // if more options is closed
            classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["albumMenu"]["topMenu"]
            classRef.middleMenuOptionsMobile = []
            classRef.bottomMenuOptionsMobile = []
        }

      }else if(file["isLoggedInUsrAlbumOwner"]== false && file["isLoggedInUsrFileOwner"] == false){
        if(classRef.openMoreOptions){
          classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["albumMenu"]["inExpandMode"]["topMenu"];
          classRef.middleMenuOptionsMobile = isFavorite?classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["albumMenu"]["inExpandMode"]["middleMenu"]["unSetFavorite"]:classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["albumMenu"]["inExpandMode"]["middleMenu"]["setFavorite"]
          classRef.bottomMenuOptionsMobile = showCoverPhotoOption?classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["albumMenu"]["inExpandMode"]["bottomMenu_notOwner"]["coverPhotoMenu"]:classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["albumMenu"]["inExpandMode"]["bottomMenu_notOwner"]["NoncoverPhotoMenu"];
        }else{ // if more options is closed
            classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["albumMenu"]["topMenu"]
            classRef.middleMenuOptionsMobile = []
            classRef.bottomMenuOptionsMobile = []
        }
      }
    }else{
      if(classRef.showPreview){
        if(file["isLoggedInUsrAlbumOwner"] || (file["isLoggedInUsrAlbumOwner"] == false && file["isLoggedInUsrFileOwner"] == true)){
          if(classRef.openMoreOptions){
            classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["albumMenu"]["inExpandMode"]["topMenu"];
            classRef.middleMenuOptionsMobile = isFavorite?classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["albumMenu"]["inExpandMode"]["middleMenu"]["unSetFavorite"]:classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["albumMenu"]["inExpandMode"]["middleMenu"]["setFavorite"]
            classRef.bottomMenuOptionsMobile = showCoverPhotoOption?classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["albumMenu"]["inExpandMode"]["bottomMenu"]["coverPhotoMenu"]:classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["albumMenu"]["inExpandMode"]["bottomMenu"]["NoncoverPhotoMenu"];
          }else{ // if more options is closed
              classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["albumMenu"]["topMenu"]
              classRef.middleMenuOptionsMobile = []
              classRef.bottomMenuOptionsMobile = []
          }
        }else if(file["isLoggedInUsrAlbumOwner"]== false && file["isLoggedInUsrFileOwner"] == false){
          if(classRef.openMoreOptions){
            classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["albumMenu"]["inExpandMode"]["topMenu"];
            classRef.middleMenuOptionsMobile = isFavorite?classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["albumMenu"]["inExpandMode"]["middleMenu"]["unSetFavorite"]:classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["albumMenu"]["inExpandMode"]["middleMenu"]["setFavorite"]
            classRef.bottomMenuOptionsMobile = showCoverPhotoOption?classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["albumMenu"]["inExpandMode"]["bottomMenu_notOwner"]["coverPhotoMenu"]:classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["albumMenu"]["inExpandMode"]["bottomMenu_notOwner"]["NoncoverPhotoMenu"];
          }else{ // if more options is closed
              classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["albumMenu"]["topMenu"]
              classRef.middleMenuOptionsMobile = []
              classRef.bottomMenuOptionsMobile = []
          }
        }
      }else{
          if(file["isLoggedInUsrAlbumOwner"] || (file["isLoggedInUsrAlbumOwner"] == false && file["isLoggedInUsrFileOwner"] == true)){
            classRef.topMenuOptions = []
            classRef.middleMenuOptionsMobile = isFavorite?classRef.topMenuMobile_MainRepo["selectionModeOff"]["albumMenu"]["middleMenu"]["unSetFavorite"]:classRef.topMenuMobile_MainRepo["selectionModeOff"]["albumMenu"]["middleMenu"]["setFavorite"]
            classRef.bottomMenuOptionsMobile = showCoverPhotoOption?classRef.topMenuMobile_MainRepo["selectionModeOff"]["albumMenu"]["bottomMenu"]["coverPhotoMenu"]:classRef.topMenuMobile_MainRepo["selectionModeOff"]["albumMenu"]["bottomMenu"]["NoncoverPhotoMenu"];
          }else if(file["isLoggedInUsrAlbumOwner"]== false && file["isLoggedInUsrFileOwner"] == false){
            classRef.topMenuOptions = []
            classRef.middleMenuOptionsMobile = isFavorite?classRef.topMenuMobile_MainRepo["selectionModeOff"]["albumMenu"]["middleMenu_notOwner"]["unSetFavorite"]:classRef.topMenuMobile_MainRepo["selectionModeOff"]["albumMenu"]["middleMenu_notOwner"]["setFavorite"]
            classRef.bottomMenuOptionsMobile = showCoverPhotoOption?classRef.topMenuMobile_MainRepo["selectionModeOff"]["albumMenu"]["bottomMenu_notOwner"]["coverPhotoMenu_notOwner"]:classRef.topMenuMobile_MainRepo["selectionModeOff"]["albumMenu"]["bottomMenu_notOwner"]["NoncoverPhotoMenu_notOwner"];
          }
          
      }
    }
    if(file["isLoggedInUsrFileOwner"] == false){
      if(classRef.bottomMenuOptionsMobile.length > 0){
        classRef.bottomMenuOptionsMobile.map((array,idx) =>{
          var findRenameOptionBottomMenu = array.find(opt=>opt["menuItem"] == "Rename");
          if(findRenameOptionBottomMenu){
            var index = classRef.bottomMenuOptionsMobile[idx].indexOf(findRenameOptionBottomMenu);
            if(index>=0){
              classRef.bottomMenuOptionsMobile[idx][index]["isDisabled"] = "disabled"
            }
          }
        })
      }
    }
  }


  getContextMenuForFavoritesTabMultipleAlbumFile(){
    var classRef = this.universalService;
    var iosDevice = this.checkIfIosDevice();
    if(classRef.openMoreOptions){
      classRef.topMenuOptions = this.favoriteMenu["selectionModeOn"]["multipleFile"]["inExpandMode"]["topMenu"];
      classRef.middleMenuOptionsMobile = this.favoriteMenu["selectionModeOn"]["multipleFile"]["inExpandMode"]["middleMenu"]["unSetFavorite"];
      classRef.bottomMenuOptionsMobile = [];
    }else{
      classRef.topMenuOptions = this.favoriteMenu["selectionModeOn"]["collapsedMode"]["topMenu"];
      classRef.middleMenuOptionsMobile = [];
      classRef.bottomMenuOptionsMobile = [];
    }
  }

  getMultipleFileContextMenu_Share(selectionMode){
    var classRef = this.universalService;
    var self = this;
    classRef.topMenuOptions  = self.iosChrome ? classRef.topMenuMobile_Share["selectionModeOn"]["multipleFile"]["fileMenu_IosChrome"]["topMenu"] : classRef.topMenuMobile_Share["selectionModeOn"]["multipleFile"]["fileMenu"]["topMenu"]
    this.removeAddtoJioCloud()
  }

  getMultipleFileContextMenu(){
    var classRef = this.universalService;
    var showAddToAlbumOption = classRef.checkIfImageAndVideosExistInSelection();
    if(classRef.currentTab == "Person Details"){
      this.getMultipleFileContextMenuForPeople();
      return
    }else if(classRef.currentTab == "Place Details"){
      this.getMultipleFileContextMenuForPlace();
      return
    } else if (this.router.url.includes('/teamfolders') ){
      this.getMultipleFileContextMenuForTeamFolder();
      return;
    }else if (this.router.url.includes('/privatefolder')){
      this.getMultipleFileContextMenuForPrivateFolder();
      return;
    }else if(this.router.url.includes('/digilocker')){
      this.getDigiLockerMultipleFileContextMenuMobile();
      return
    }
    var isFavorite;  
    isFavorite = this.checkFavoriteStatus();
    if(classRef.openMoreOptions){ // if more options is open
      classRef.topMenuOptions  = classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["fileMenu"]["inExpandMode"]["topMenu"];
      classRef.middleMenuOptionsMobile = isFavorite?classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["fileMenu"]["inExpandMode"]["middleMenu"]["unSetFavorite"]:classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["fileMenu"]["inExpandMode"]["middleMenu"]["setFavorite"];
      classRef.bottomMenuOptionsMobile = showAddToAlbumOption ? classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["fileMenu"]["inExpandMode"]["bottomMenu"] : classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["fileMenu"]["inExpandMode"]["bottomMenu_Other_Than_Images_And_Videos"]
    }else{ // if more options is closed
      if(classRef.activeRepo == 'invite'){
        classRef.topMenuOptions  = classRef.topMenuMobile_MainRepo["selectionModeOn"]["albumInvite"]["topMenu"];
        classRef.middleMenuOptionsMobile = [];
        classRef.bottomMenuOptionsMobile = [];
      }else{
        classRef.topMenuOptions  = showAddToAlbumOption ? classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["multipleFile"]["fileMenu"]["topMenu"] : classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["multipleFile"]["fileMenu"]["topMenu_Other_Than_Images_And_Videos"];
        // classRef.topMenuOptions  = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["fileMenu"]["topMenu"];
        classRef.middleMenuOptionsMobile = [];
        classRef.bottomMenuOptionsMobile = [];
      }
      
    }
      this.removePrivateFolderOption();
  }

  getMultipleFileContextMenuForPrivateFolder(){
    var classRef = this.universalService;
    var file = classRef.selectedNodes[0];
    if(file == undefined)
     return
    
    if(classRef.openMoreOptions){ // if more options is open
      classRef.topMenuOptions  = classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["fileMenu"]["inExpandMode"]["insidePrivateFolder"]["topMenu"];
      //classRef.middleMenuOptionsMobile = isFavorite?classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["fileMenu"]["inExpandMode"]["middleMenu"]["unSetFavorite"]:classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["fileMenu"]["inExpandMode"]["middleMenu"]["setFavorite"];
      classRef.bottomMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["fileMenu"]["inExpandMode"]["insidePrivateFolder"]["bottomMenu"]
    }else{ // if more options is closed
      classRef.topMenuOptions  = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["multipleFile"]["fileMenu"]["insidePrivateFolder"]["topMenu"];
      // classRef.topMenuOptions  = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["fileMenu"]["topMenu"];
      classRef.middleMenuOptionsMobile = [];
      classRef.bottomMenuOptionsMobile = [];
    }
  }

  getMultipleFileContextMenuForTeamFolder(){
    var classRef = this.universalService;
    var file = classRef.selectedNodes[0];
    if(file == undefined)
     return
    var roleCode = this.getTFRoleCodeDetail(file["roleCode"]);

    if(classRef.openMoreOptions){ // if more options is open
      classRef.topMenuOptions  = classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["fileMenu"]["inExpandMode"]["insideTeamFolders"][roleCode]["topMenu"];
      //classRef.middleMenuOptionsMobile = isFavorite?classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["fileMenu"]["inExpandMode"]["middleMenu"]["unSetFavorite"]:classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["fileMenu"]["inExpandMode"]["middleMenu"]["setFavorite"];
      classRef.bottomMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["fileMenu"]["inExpandMode"]["insideTeamFolders"][roleCode]["bottomMenu"]
    }else{ // if more options is closed
      classRef.topMenuOptions  = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["multipleFile"]["fileMenu"]["insideTeamFolders"][roleCode]["topMenu"];
      // classRef.topMenuOptions  = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["fileMenu"]["topMenu"];
      classRef.middleMenuOptionsMobile = [];
      classRef.bottomMenuOptionsMobile = [];
    }
  }

  getMultipleFileContextMenuForPeople(){
    var classRef = this.universalService;
    var isFavorite;  
    isFavorite = this.checkFavoriteStatus();
    if(classRef.openMoreOptions){ // if more options is open
      classRef.topMenuOptions  = classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["peopleTab"]["inExpandMode"]["topMenu"];
      classRef.middleMenuOptionsMobile = isFavorite?classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["peopleTab"]["inExpandMode"]["middleMenu"]["unSetFavorite"]:classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["fileMenu"]["inExpandMode"]["middleMenu"]["setFavorite"];
      classRef.bottomMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["peopleTab"]["inExpandMode"]["bottomMenu"]
    }else{ // if more options is closed
      classRef.topMenuOptions  = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["multipleFile"]["peopleTab"]["topMenu"];
      // classRef.topMenuOptions  = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["fileMenu"]["topMenu"];
      classRef.middleMenuOptionsMobile = [];
      classRef.bottomMenuOptionsMobile = [];
    }
  }

  getMultipleFileContextMenuForPlace(){
    var classRef = this.universalService;
    var isFavorite;  
    isFavorite = this.checkFavoriteStatus();
    if(classRef.openMoreOptions){ // if more options is open
      classRef.topMenuOptions  = classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["placeTab"]["inExpandMode"]["topMenu"];
      classRef.middleMenuOptionsMobile = isFavorite?classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["placeTab"]["inExpandMode"]["middleMenu"]["unSetFavorite"]:classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["fileMenu"]["inExpandMode"]["middleMenu"]["setFavorite"];
      classRef.bottomMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["placeTab"]["inExpandMode"]["bottomMenu"]
    }else{ // if more options is closed
      classRef.topMenuOptions  = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["multipleFile"]["placeTab"]["topMenu"];
      // classRef.topMenuOptions  = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["fileMenu"]["topMenu"];
      classRef.middleMenuOptionsMobile = [];
      classRef.bottomMenuOptionsMobile = [];
    }
  }

  findFileOwner(){
    var classRef = this.universalService;
    this.filesNotOwnedByUser =[];
    classRef.selectedNodes.filter(objType=>{
      if(objType["FullObject"]){
        if(objType["FullObject"]["isLoggedInUsrFileOwner"] == false && objType["FullObject"]["isLoggedInUsrAlbumOwner"]== false )
        this.filesNotOwnedByUser.push(objType)
      }else{
        if(objType["isLoggedInUsrFileOwner"] ==  false && objType["isLoggedInUsrAlbumOwner"] ==  false)
        this.filesNotOwnedByUser.push(objType)
      }
    })
  }

  async getContextMenuForMultipleAlbumFiles(){
    var classRef = this.universalService;
    var isFavorite,iosDevice;  
    isFavorite = this.checkFavoriteStatus();
    iosDevice = this.checkIfIosDevice();
    await this.findFileOwner();
    if(this.filesNotOwnedByUser.length == 0){
      if(classRef.openMoreOptions){
        classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["albumMenu"]["inExpandMode"]["topMenu"];
        classRef.middleMenuOptionsMobile = isFavorite?classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["albumMenu"]["inExpandMode"]["middleMenu"]["unSetFavorite"]:classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["albumMenu"]["inExpandMode"]["middleMenu"]["setFavorite"];
        classRef.bottomMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["albumMenu"]["inExpandMode"]["bottomMenu"];
      }else{
        classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["albumMenu"]["topMenu"];
        classRef.middleMenuOptionsMobile = [];
        classRef.bottomMenuOptionsMobile = [];
      }
    }else if(this.filesNotOwnedByUser.length >=1){
      if(classRef.openMoreOptions){
        classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["albumMenu"]["inExpandMode"]["topMenu"];
        classRef.middleMenuOptionsMobile = isFavorite?classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["albumMenu"]["inExpandMode"]["middleMenu"]["unSetFavorite"]:classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["albumMenu"]["inExpandMode"]["middleMenu"]["setFavorite"];
        classRef.bottomMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["albumMenu"]["inExpandMode"]["bottomMenu_notOwner"];
      }else{
        classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["albumMenu"]["topMenu"];
        classRef.middleMenuOptionsMobile = [];
        classRef.bottomMenuOptionsMobile = [];
      }
    }

  }

  getMultipleFolderContextMenu_Share(selectionMode){
    var classRef = this.universalService;
    var self = this;
    classRef.topMenuOptions  = self.iosChrome ? classRef.topMenuMobile_Share["selectionModeOn"]["multipleFile"]["folderMenu_IosChrome"]["topMenu"] : classRef.topMenuMobile_Share["selectionModeOn"]["multipleFile"]["folderMenu"]["topMenu"]
  }

  getMultipleFolderContextMenu(){
    var classRef = this.universalService;
    if(classRef.openMoreOptions){ // if more options is open
      classRef.topMenuOptions  = classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["folderMenu"]["inExpandMode"]["topMenu"];
      classRef.middleMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["folderMenu"]["inExpandMode"]["middleMenu"]["setFavorite"];
      classRef.bottomMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["folderMenu"]["inExpandMode"]["bottomMenu"]
    }else{ // if more options is closed
      classRef.topMenuOptions  = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["multipleFile"]["folderMenu"]["topMenu"];
      // classRef.topMenuOptions  = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["folderMenu"]["topMenu"];
      classRef.middleMenuOptionsMobile = [];
      classRef.bottomMenuOptionsMobile = [];
    }
      this.removePrivateFolderOption();
  }

  getMultipleFolderContextMenuForPrivateFolder(){
    var classRef = this.universalService;
    if(classRef.openMoreOptions){ // if more options is open
      classRef.topMenuOptions  = classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["folderMenu"]["inExpandMode"]["insidePrivateFolder"]["topMenu"];
      classRef.middleMenuOptionsMobile = [];//classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["folderMenu"]["inExpandMode"]["middleMenu"]["setFavorite"];
      classRef.bottomMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["folderMenu"]["inExpandMode"]["insidePrivateFolder"]["bottomMenu"]
    }else{ // if more options is closed
      classRef.topMenuOptions  = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["multipleFile"]["folderMenu"]["insidePrivateFolder"]["topMenu"];
      // classRef.topMenuOptions  = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["folderMenu"]["topMenu"];
      classRef.middleMenuOptionsMobile = [];
      classRef.bottomMenuOptionsMobile = [];
    }
  }

  getMultipleFolderContextMenuForTeamFolder(file){
    var classRef = this.universalService;
    var roleCode = this.getTFRoleCodeDetail(file["roleCode"]);

    if(classRef.openMoreOptions){ // if more options is open
      classRef.topMenuOptions  = classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["folderMenu"]["inExpandMode"]["insideTeamFolders"][roleCode]["topMenu"];
      //classRef.middleMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["folderMenu"]["inExpandMode"]["middleMenu"]["setFavorite"];
      classRef.bottomMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["folderMenu"]["inExpandMode"]["insideTeamFolders"][roleCode]["bottomMenu"]
    }else{ // if more options is closed
      classRef.topMenuOptions  = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["multipleFile"]["folderMenu"]["insideTeamFolders"]["owner"]["topMenu"];

      // classRef.topMenuOptions  = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["folderMenu"]["topMenu"];
      classRef.middleMenuOptionsMobile = [];
      classRef.bottomMenuOptionsMobile = [];
    }
  }

  getContextMenuForTrashFiles(){
    var classRef = this.universalService;  
    if(classRef.openMoreOptions){
      classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["Trash_FileMenu"]["inExpandMode"]["topMenu"];
    }else{
      classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["Trash_FileMenu"]["collapsedMode"]["topMenu"];
    }
    classRef.middleMenuOptionsMobile = [];
    classRef.bottomMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["Trash_FileMenu"]["inExpandMode"]["bottomMenu"];
  }

  getContextMenuForSharedLinkByMe(){
    var classRef = this.universalService;  
    if(classRef.openMoreOptions){
      classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["SharedLinkByMe_FileMenu"]["inExpandMode"]["topMenu"];
    }else{
      classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["SharedLinkByMe_FileMenu"]["collapsedMode"]["topMenu"];
    }
    classRef.middleMenuOptionsMobile = [];
    classRef.bottomMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["SharedLinkByMe_FileMenu"]["inExpandMode"]["bottomMenu"];
  }

  getDefaultIconContentForObjects(){
    
    var format= '';
    var defaultContent='';
    var classRef = this.universalService;
    if(classRef.selectedNodes && classRef.selectedNodes.length >= 1){
      if(classRef.selectedNodes[0]["isBackupDevices"] == 'Y'){
        format = 'BACKUP_DEVICE'
      }else{
        format = classRef.selectedNodes[0]["format"].substring(0,1).toUpperCase() + classRef.selectedNodes[0]["format"].substring(1);  
      }
    }
    defaultContent = this.universalService.topMenuMobile["Default_Thumbnail_Content"][format];
    classRef.topMenuOptions["defaultContent"] = defaultContent;
  }



  checkFavoriteStatus(){
    var classRef = this.universalService;
    var checkFavoritedFiles = [];
    classRef.selectedNodes.map(fav=>{
      if(fav["FullObject"]){
        if(fav["FullObject"]["isFavorite"] == true)
        checkFavoritedFiles.push(fav)
      }else{  
        if(fav["isFavorite"] == true)
        checkFavoritedFiles.push(fav)
      } 
  })

  if(checkFavoritedFiles.length == classRef.selectedNodes.length){
        return true;
      }
      return false;
  }

  checkIfIosDevice(){
    var classRef = this.universalService;
    var os = classRef.browserDetails.os.name;
    var browser = classRef.browserDetails.browser.name;
    if(os == 'iOS' &&  browser == "Chrome"){
      return true;
    }else{
      return false;
    }
  }

  checkIfSetCoverPhotoShouldBeShown(file){
    var classRef = this.universalService;
    if(file["format"] == 'image'){
      if(file["objectKey"] == classRef.currentAlbum?.["boardCoverPicObjectKey"]){
        return false;
      }else{
        return true;
      }
    }else{
      return false;
    }
  }


  checkAlbumFilesStatus(){
    var classRef = this.universalService;
    var checkForAlbumFiles = [];
    classRef.selectedNodes.filter(objType=>{
      if(objType["FullObject"]){
        if(objType["FullObject"]["objectType"] != "FE" && objType["FullObject"]["objectType"] != "FR")
        checkForAlbumFiles.push(objType)
      }else{
        if(objType["objectType"] != "FE" && objType["objectType"] != "FR") 
        checkForAlbumFiles.push(objType)
      }
    })
    return checkForAlbumFiles
  }

  decideTabNameFromSharedFiles(){
    var url = window.location.href;
    if(url.includes('sharedbyme')){
      return 'sent';
    }else if (url.includes('sharedwithme')){
      return 'received';
    }
  }

  getContextMenuForTeamFolders(file){
    var classRef = this.universalService;
    let options = [];
    if(file["roleCode"] == "O"){
      options = classRef.topMenuMobile_MainRepo["selectionModeOff"]["teamFolder"]["bottomMenu"]["owner"];
    }
    else if(file["roleCode"] == "E"){
      options = classRef.topMenuMobile_MainRepo["selectionModeOff"]["teamFolder"]["bottomMenu"]["editor"];
    }
    else  {
      options = classRef.topMenuMobile_MainRepo["selectionModeOff"]["teamFolder"]["bottomMenu"]["viewer"];
    }
    classRef.bottomMenuOptionsMobile = options;
  }

  getContextMenuForInsideTeamFolders(selectionMode, file) {
    var classRef = this.universalService;
    var roleCode = this.getTFRoleCodeDetail(file["roleCode"]);
    if(selectionMode){ // if selection mode is on
      if(classRef.openMoreOptions){ // if the menu is expanded form
        
        classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["folderMenu"]["inExpandMode"]["insideTeamFolders"][roleCode]["topMenu"]
        //classRef.middleMenuOptionsMobile = isFavorite?classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["folderMenu"]["inExpandMode"]["middleMenu"]["unSetFavorite"]:classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["folderMenu"]["inExpandMode"]["middleMenu"]["setFavorite"]
        classRef.bottomMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["folderMenu"]["inExpandMode"]["insideTeamFolders"][roleCode]["bottomMenu"]
      }else{ // if the menu is collapsed form
        // classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["folderMenu"]["topMenu"]
        classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["singleFile"]["insideTeamFolders"][roleCode]["topMenu"];
        classRef.middleMenuOptionsMobile = []
        classRef.bottomMenuOptionsMobile = []
      }
    }else{
      classRef.topMenuOptions  = [];
      classRef.middleMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOff"]["folderMenu"]["insideTeamFolders"][roleCode]["middleMenu"];
      classRef.bottomMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOff"]["folderMenu"]["insideTeamFolders"][roleCode]["bottomMenu"];
    }
  }

  getContextMenuForInsidePrivateFolder(selectionMode, file) {
    var classRef = this.universalService;
    if(selectionMode){ // if selection mode is on
      if(classRef.openMoreOptions){ // if the menu is expanded form
        classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["folderMenu"]["inExpandMode"]["insidePrivateFolder"]["topMenu"]
        classRef.bottomMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["folderMenu"]["inExpandMode"]["insidePrivateFolder"]["bottomMenu"]
      }else{ // if the menu is collapsed form
        classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["singleFile"]["insidePrivateFolder"]["topMenu"];
        classRef.middleMenuOptionsMobile = []
        classRef.bottomMenuOptionsMobile = []
      }
    }else{
      classRef.topMenuOptions  = [];
      classRef.middleMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOff"]["folderMenu"]["insidePrivateFolder"]["middleMenu"];
      classRef.bottomMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOff"]["folderMenu"]["insidePrivateFolder"]["bottomMenu"];
    }
  }
  

  getContextMenuForSingleSharedFile(file,mobileSelectionMode){
    var classRef = this.universalService;
    var tab = this.decideTabNameFromSharedFiles();
    if(tab == 'sent'){
      if(file["editAccess"] == true){
        this.sharedByMeSingleSharedFileContextMenuWithEditAccess(mobileSelectionMode)
      }else{
        console.log("shared by me cannot have read access, it will always have edit access.")
      }
    }else if (tab == 'received'){
      if(file["editAccess"] == true){
        if(!this.universalService.openFolderContent){ // user is on the rootlevel of shared with me tab and folder is not opened
          this.sharedWithMeSingleSharedFileContextMenuWithEditAccessRootLevel(file, mobileSelectionMode)
        }else{
        this.sharedWithMeSingleSharedFileContextMenuWithEditAccess(file, mobileSelectionMode)
        }
      }else{
        if(!this.universalService.openFolderContent){ // user is on the rootlevel of shared with me tab and folder is not opened
          this.sharedWithMeSingleSharedFileContextMenuWithReadAccessRootLevel(file, mobileSelectionMode)
        }else{
        this.sharedWithMeSingleSharedFileContextMenuWithReadAccess(file, mobileSelectionMode)
        }
      }
    }
  }

  sharedByMeSingleSharedFileContextMenuWithEditAccess(mobileSelectionMode){
    var classRef = this.universalService;
    if(mobileSelectionMode){
      if(classRef.openMoreOptions){ //expanded mode
        classRef.topMenuOptions  = this.sharedByMe["EditAccess"]["selectionModeOn"]["singleFile"]["inExpandMode"]["topMenu"];
        classRef.middleMenuOptionsMobile = [];
        classRef.bottomMenuOptionsMobile = this.sharedByMe["EditAccess"]["selectionModeOn"]["singleFile"]["inExpandMode"]["bottomMenu"]
      }else{
        classRef.topMenuOptions  = this.sharedByMe["EditAccess"]["selectionModeOn"]["singleFile"]["collapsedMode"]["topMenu"];
        classRef.middleMenuOptionsMobile = [];
        classRef.bottomMenuOptionsMobile = [];
      }
    }else{
      if(this.universalService.showPreview){
        if(classRef.openMoreOptions){ // if more options is open
          classRef.topMenuOptions = this.sharedByMe["EditAccess"]["selectionModeOn"]["singleFile"]["inExpandMode"]["topMenu"]
          classRef.middleMenuOptionsMobile = [];
          classRef.bottomMenuOptionsMobile = this.sharedByMe["EditAccess"]["selectionModeOn"]["singleFile"]["inExpandMode"]["bottomMenu"]
        }else{ // if more options is closed
          classRef.topMenuOptions  = this.sharedByMe["EditAccess"]["selectionModeOn"]["singleFile"]["collapsedMode"]["topMenu"];
          classRef.middleMenuOptionsMobile = []
          classRef.bottomMenuOptionsMobile = []
        }
      }else{
        classRef.topMenuOptions  = [];
        classRef.middleMenuOptionsMobile = [];
        classRef.bottomMenuOptionsMobile = this.sharedByMe["EditAccess"]["selectionModeOff"]["bottomMenu"];
      } 
    }
  }

  sharedWithMeSingleSharedFileContextMenuWithEditAccess(file, mobileSelectionMode){
    var classRef = this.universalService;
    if(mobileSelectionMode){
      if(classRef.openMoreOptions){ //expanded mode
        if(file["objectType"] == "FR"){
          classRef.topMenuOptions  = this.sharedWithMe["EditAccess"]["selectionModeOn"]["singleFile"]["FolderMenu"]["inExpandMode"]["topMenu"];
          classRef.middleMenuOptionsMobile = [];
          classRef.bottomMenuOptionsMobile = this.sharedWithMe["EditAccess"]["selectionModeOn"]["singleFile"]["FolderMenu"]["inExpandMode"]["bottomMenu"]
        } else {
          classRef.topMenuOptions  = this.sharedWithMe["EditAccess"]["selectionModeOn"]["singleFile"]["FileMenu"]["inExpandMode"]["topMenu"];
          classRef.middleMenuOptionsMobile = [];
          classRef.bottomMenuOptionsMobile = this.sharedWithMe["EditAccess"]["selectionModeOn"]["singleFile"]["FileMenu"]["inExpandMode"]["bottomMenu"]
        }
      }else{
        if(file["objectType"] == "FR"){
          classRef.topMenuOptions  = this.sharedWithMe["EditAccess"]["selectionModeOn"]["singleFile"]["FolderMenu"]["collapsedMode"]["topMenu"];
          classRef.middleMenuOptionsMobile = [];
          classRef.bottomMenuOptionsMobile = [];
        } else {
          classRef.topMenuOptions  = this.sharedWithMe["EditAccess"]["selectionModeOn"]["singleFile"]["FileMenu"]["collapsedMode"]["topMenu"];
          classRef.middleMenuOptionsMobile = [];
          classRef.bottomMenuOptionsMobile = [];
        }
      }
    }else{
      if(this.universalService.showPreview){
        if(classRef.openMoreOptions){ // if more options is open
          if(file["objectType"] == "FR"){
            classRef.topMenuOptions = this.sharedWithMe["EditAccess"]["selectionModeOn"]["singleFile"]["FolderMenu"]["inExpandMode"]["topMenu"]
            classRef.middleMenuOptionsMobile = [];
            classRef.bottomMenuOptionsMobile = this.sharedWithMe["EditAccess"]["selectionModeOn"]["singleFile"]["FolderMenu"]["inExpandMode"]["bottomMenu"]
          } else {
            classRef.topMenuOptions = this.sharedWithMe["EditAccess"]["selectionModeOn"]["singleFile"]["FileMenu"]["inExpandMode"]["topMenu"]
            classRef.middleMenuOptionsMobile = [];
            classRef.bottomMenuOptionsMobile = this.sharedWithMe["EditAccess"]["selectionModeOn"]["singleFile"]["FileMenu"]["inExpandMode"]["bottomMenu"]
          }
        }else{ // if more options is closed
          if(file["objectType"] == "FR"){
            classRef.topMenuOptions  = this.sharedWithMe["EditAccess"]["selectionModeOn"]["singleFile"]["FolderMenu"]["collapsedMode"]["topMenu"];
            classRef.middleMenuOptionsMobile = []
            classRef.bottomMenuOptionsMobile = []
          } else {
            classRef.topMenuOptions  = this.sharedWithMe["EditAccess"]["selectionModeOn"]["singleFile"]["FileMenu"]["collapsedMode"]["topMenu"];
            classRef.middleMenuOptionsMobile = []
            classRef.bottomMenuOptionsMobile = []
          }
        }
      }else{
        if(file["objectType"] == "FR"){
          classRef.topMenuOptions = [];
          classRef.middleMenuOptionsMobile = [];
          classRef.bottomMenuOptionsMobile = this.sharedWithMe["EditAccess"]["selectionModeOff"]["FolderMenu"]["bottomMenu"];
        } else {
          classRef.topMenuOptions = [];
          classRef.middleMenuOptionsMobile = [];
          classRef.bottomMenuOptionsMobile = this.sharedWithMe["EditAccess"]["selectionModeOff"]["FileMenu"]["bottomMenu"];
        }
      }
    }
  }

  sharedWithMeSingleSharedFileContextMenuWithEditAccessRootLevel(file, mobileSelectionMode){
    var classRef = this.universalService;
    if(mobileSelectionMode){
      if(classRef.openMoreOptions){ //expanded mode
        if(file["objectType"] == "FR"){  // if folder is selected
          classRef.topMenuOptions  = this.sharedWithMe["EditAccess"]["rootLevelOptions"]["selectionModeOn"]["singleFile"]["FolderMenu"]["inExpandMode"]["topMenu"];
          classRef.middleMenuOptionsMobile = [];
          classRef.bottomMenuOptionsMobile = this.sharedWithMe["EditAccess"]["rootLevelOptions"]["selectionModeOn"]["singleFile"]["FolderMenu"]["inExpandMode"]["bottomMenu"]
        } else {
          classRef.topMenuOptions  = this.sharedWithMe["EditAccess"]["rootLevelOptions"]["selectionModeOn"]["singleFile"]["FileMenu"]["inExpandMode"]["topMenu"];
          classRef.middleMenuOptionsMobile = [];
          classRef.bottomMenuOptionsMobile = this.sharedWithMe["EditAccess"]["rootLevelOptions"]["selectionModeOn"]["singleFile"]["FileMenu"]["inExpandMode"]["bottomMenu"]
        }
        
      }else{
        if(file["objectType"] == "FR"){
          classRef.topMenuOptions  = this.sharedWithMe["EditAccess"]["rootLevelOptions"]["selectionModeOn"]["singleFile"]["FolderMenu"]["collapsedMode"]["topMenu"];
          classRef.middleMenuOptionsMobile = [];
          classRef.bottomMenuOptionsMobile = [];
        } else {
          classRef.topMenuOptions  = this.sharedWithMe["EditAccess"]["rootLevelOptions"]["selectionModeOn"]["singleFile"]["FileMenu"]["collapsedMode"]["topMenu"];
          classRef.middleMenuOptionsMobile = [];
          classRef.bottomMenuOptionsMobile = [];
        }
        
      }
    }else{
      if(this.universalService.showPreview){
        if(classRef.openMoreOptions){ // if more options is open
          if(file["objectType"] == "FR"){  // if folder is selected
            classRef.topMenuOptions = this.sharedWithMe["EditAccess"]["rootLevelOptions"]["selectionModeOn"]["singleFile"]["FolderMenu"]["inExpandMode"]["topMenu"]
            classRef.middleMenuOptionsMobile = [];
            classRef.bottomMenuOptionsMobile = this.sharedWithMe["EditAccess"]["rootLevelOptions"]["selectionModeOn"]["singleFile"]["FolderMenu"]["inExpandMode"]["bottomMenu"]
          } else {
            classRef.topMenuOptions = this.sharedWithMe["EditAccess"]["rootLevelOptions"]["selectionModeOn"]["singleFile"]["FileMenu"]["inExpandMode"]["topMenu"]
            classRef.middleMenuOptionsMobile = [];
            classRef.bottomMenuOptionsMobile = this.sharedWithMe["EditAccess"]["rootLevelOptions"]["selectionModeOn"]["singleFile"]["FileMenu"]["inExpandMode"]["bottomMenu"]
          }
        }else{ // if more options is closed
          if(file["objectType"] == "FR"){
            classRef.topMenuOptions  = this.sharedWithMe["EditAccess"]["rootLevelOptions"]["selectionModeOn"]["singleFile"]["FolderMenu"]["collapsedMode"]["topMenu"];
            classRef.middleMenuOptionsMobile = []
            classRef.bottomMenuOptionsMobile = []
          } else {
            classRef.topMenuOptions  = this.sharedWithMe["EditAccess"]["rootLevelOptions"]["selectionModeOn"]["singleFile"]["FileMenu"]["collapsedMode"]["topMenu"];
            classRef.middleMenuOptionsMobile = []
            classRef.bottomMenuOptionsMobile = []
          }
        }
      }else{
        if(file["objectType"] == "FR"){
          classRef.topMenuOptions = [];
          classRef.middleMenuOptionsMobile = [];
          classRef.bottomMenuOptionsMobile = this.sharedWithMe["EditAccess"]["rootLevelOptions"]["selectionModeOff"]["FolderMenu"]["bottomMenu"];
        } else {
          classRef.topMenuOptions = [];
          classRef.middleMenuOptionsMobile = [];
          classRef.bottomMenuOptionsMobile = this.sharedWithMe["EditAccess"]["rootLevelOptions"]["selectionModeOff"]["FileMenu"]["bottomMenu"];
        }
        
      }
    }
  }

  sharedWithMeSingleSharedFileContextMenuWithReadAccess(file, mobileSelectionMode){
    var classRef = this.universalService;
    if(mobileSelectionMode){
      if(classRef.openMoreOptions){ //expanded mode
        if(file["objectType"] == "FR"){
          classRef.topMenuOptions  = this.sharedWithMe["ReadAccess"]["selectionModeOn"]["singleFile"]["FolderMenu"]["inExpandMode"]["topMenu"];
          classRef.middleMenuOptionsMobile = [];
          classRef.bottomMenuOptionsMobile = this.sharedWithMe["ReadAccess"]["selectionModeOn"]["singleFile"]["FolderMenu"]["inExpandMode"]["bottomMenu"];
        } else {
          classRef.topMenuOptions  = this.sharedWithMe["ReadAccess"]["selectionModeOn"]["singleFile"]["FileMenu"]["inExpandMode"]["topMenu"];
          classRef.middleMenuOptionsMobile = [];
          classRef.bottomMenuOptionsMobile = this.sharedWithMe["ReadAccess"]["selectionModeOn"]["singleFile"]["FileMenu"]["inExpandMode"]["bottomMenu"];
        }
      }else{
        if(file["objectType"] == "FR"){
          classRef.topMenuOptions  = this.sharedWithMe["ReadAccess"]["selectionModeOn"]["singleFile"]["FolderMenu"]["collapsedMode"]["topMenu"];
          classRef.middleMenuOptionsMobile = [];
          classRef.bottomMenuOptionsMobile = [];
        } else {
          classRef.topMenuOptions  = this.sharedWithMe["ReadAccess"]["selectionModeOn"]["singleFile"]["FileMenu"]["collapsedMode"]["topMenu"];
          classRef.middleMenuOptionsMobile = [];
          classRef.bottomMenuOptionsMobile = [];
        }
      }
    }else{
      if(this.universalService.showPreview){
        if(classRef.openMoreOptions){ // if more options is open
          if(file["objectType"] == "FR"){
            classRef.topMenuOptions = this.sharedWithMe["ReadAccess"]["selectionModeOn"]["singleFile"]["FolderMenu"]["inExpandMode"]["topMenu"]
            classRef.middleMenuOptionsMobile = [];
            classRef.bottomMenuOptionsMobile = this.sharedWithMe["ReadAccess"]["selectionModeOn"]["singleFile"]["FolderMenu"]["inExpandMode"]["bottomMenu"]
          } else {
            classRef.topMenuOptions = this.sharedWithMe["ReadAccess"]["selectionModeOn"]["singleFile"]["FileMenu"]["inExpandMode"]["topMenu"]
            classRef.middleMenuOptionsMobile = [];
            classRef.bottomMenuOptionsMobile = this.sharedWithMe["ReadAccess"]["selectionModeOn"]["singleFile"]["FileMenu"]["inExpandMode"]["bottomMenu"]
          }
        }else{ // if more options is closed
          if(file["objectType"] == "FR"){
            classRef.topMenuOptions  = this.sharedWithMe["ReadAccess"]["selectionModeOn"]["singleFile"]["FolderMenu"]["collapsedMode"]["topMenu"];
            classRef.middleMenuOptionsMobile = []
            classRef.bottomMenuOptionsMobile = []
          } else {
            classRef.topMenuOptions  = this.sharedWithMe["ReadAccess"]["selectionModeOn"]["singleFile"]["FileMenu"]["collapsedMode"]["topMenu"];
            classRef.middleMenuOptionsMobile = []
            classRef.bottomMenuOptionsMobile = []
          }
        }
      }else{
        if(file["objectType"] == "FR"){
          classRef.topMenuOptions = [];
          classRef.middleMenuOptionsMobile = [];
          classRef.bottomMenuOptionsMobile = this.sharedWithMe["ReadAccess"]["selectionModeOff"]["FolderMenu"]["bottomMenu"];
        } else {
          classRef.topMenuOptions = [];
          classRef.middleMenuOptionsMobile = [];
          classRef.bottomMenuOptionsMobile = this.sharedWithMe["ReadAccess"]["selectionModeOff"]["FileMenu"]["bottomMenu"];
        }
      }
    }
  }

  sharedWithMeSingleSharedFileContextMenuWithReadAccessRootLevel(file, mobileSelectionMode){
    var classRef = this.universalService;
    if(mobileSelectionMode){
      if(classRef.openMoreOptions){ //expanded mode
        if(file["objectType"] == "FR"){
          classRef.topMenuOptions  = this.sharedWithMe["ReadAccess"]["rootLevelOptions"]["selectionModeOn"]["singleFile"]["FolderMenu"]["inExpandMode"]["topMenu"];
          classRef.middleMenuOptionsMobile = [];
          classRef.bottomMenuOptionsMobile = this.sharedWithMe["ReadAccess"]["rootLevelOptions"]["selectionModeOn"]["singleFile"]["FolderMenu"]["inExpandMode"]["bottomMenu"];
        } else {
          classRef.topMenuOptions  = this.sharedWithMe["ReadAccess"]["rootLevelOptions"]["selectionModeOn"]["singleFile"]["FileMenu"]["inExpandMode"]["topMenu"];
          classRef.middleMenuOptionsMobile = [];
          // classRef.bottomMenuOptionsMobile =[] //387089 fix
          classRef.bottomMenuOptionsMobile = this.sharedWithMe["ReadAccess"]["rootLevelOptions"]["selectionModeOn"]['singleFile']["FileMenu"]['inExpandMode']["bottomMenu"];
        }
        
      }else{
        if(file["objectType"] == "FR"){
          classRef.topMenuOptions  = this.sharedWithMe["ReadAccess"]["rootLevelOptions"]["selectionModeOn"]["singleFile"]["FolderMenu"]["collapsedMode"]["topMenu"];
          classRef.middleMenuOptionsMobile = [];
          classRef.bottomMenuOptionsMobile = [];
        } else {
          classRef.topMenuOptions  = this.sharedWithMe["ReadAccess"]["rootLevelOptions"]["selectionModeOn"]["singleFile"]["FileMenu"]["collapsedMode"]["topMenu"];
          classRef.middleMenuOptionsMobile = [];
          classRef.bottomMenuOptionsMobile = [];
        }
      }
    }else{
      if(this.universalService.showPreview){
        if(classRef.openMoreOptions){ // if more options is open
          if(file["objectType"] == "FR"){
            classRef.topMenuOptions = this.sharedWithMe["ReadAccess"]["rootLevelOptions"]["selectionModeOn"]["singleFile"]["FolderMenu"]["inExpandMode"]["topMenu"]
            classRef.middleMenuOptionsMobile = [];
            classRef.bottomMenuOptionsMobile = this.sharedWithMe["ReadAccess"]["rootLevelOptions"]["selectionModeOn"]["singleFile"]["FolderMenu"]["inExpandMode"]["bottomMenu"]
          } else {
            classRef.topMenuOptions = this.sharedWithMe["ReadAccess"]["rootLevelOptions"]["selectionModeOn"]["singleFile"]["FileMenu"]["inExpandMode"]["topMenu"]
            classRef.middleMenuOptionsMobile = [];
            classRef.bottomMenuOptionsMobile = this.sharedWithMe["ReadAccess"]["rootLevelOptions"]["selectionModeOn"]["singleFile"]["FileMenu"]["inExpandMode"]["bottomMenu"]
          }
        }else{ // if more options is closed
          if(file["objectType"] == "FR"){
            classRef.topMenuOptions  = this.sharedWithMe["ReadAccess"]["rootLevelOptions"]["selectionModeOn"]["singleFile"]["FolderMenu"]["collapsedMode"]["topMenu"];
            classRef.middleMenuOptionsMobile = []
            classRef.bottomMenuOptionsMobile = []
          } else {
            classRef.topMenuOptions  = this.sharedWithMe["ReadAccess"]["rootLevelOptions"]["selectionModeOn"]["singleFile"]["FileMenu"]["collapsedMode"]["topMenu"];
            classRef.middleMenuOptionsMobile = []
            classRef.bottomMenuOptionsMobile = []
          }
        }
      }else{
        if(file["objectType"] == "FR"){
          classRef.topMenuOptions = [];
          classRef.middleMenuOptionsMobile = [];
          classRef.bottomMenuOptionsMobile = this.sharedWithMe["ReadAccess"]["rootLevelOptions"]["selectionModeOff"]["FolderMenu"]["bottomMenu"];
        } else {
          classRef.topMenuOptions = [];
          classRef.middleMenuOptionsMobile = [];
          classRef.bottomMenuOptionsMobile = this.sharedWithMe["ReadAccess"]["rootLevelOptions"]["selectionModeOff"]["FileMenu"]["bottomMenu"];
        }
      }
    }
  }



  getContextMenuForMultipleSharedFiles(mobileSelectionMode){
    var classRef = this.universalService;
    var tab = this.decideTabNameFromSharedFiles();
    classRef.haveEditAccess();
    if(tab == 'sent'){
      if(classRef.hasEditAccess == true){
        if(!this.universalService.openFolderContent){ // user is on the rootlevel of shared with me tab and folder is not opened
          this.sharedByMeMultipleSharedFileContextMenuWithEditAccessRootLevel(mobileSelectionMode)
        }else{
          this.sharedByMeMultipleSharedFileContextMenuWithEditAccess(mobileSelectionMode)
        }
      }else{
        console.log("shared by me cannot have read access, it will always have edit access.")
      }
    }else if (tab == 'received'){
      if(classRef.hasEditAccess == true){
        if(!this.universalService.openFolderContent){ // user is on the rootlevel of shared with me tab and folder is not opened
          this.sharedWithMeMultipleSharedFileContextMenuWithEditAccessRootLevel(mobileSelectionMode)
        }else{
        this.sharedWithMeMultipleSharedFileContextMenuWithEditAccess(mobileSelectionMode)
        }
      }else{
        if(!this.universalService.openFolderContent){ // user is on the rootlevel of shared with me tab and folder is not opened
          this.sharedWithMeMultipleSharedFileContextMenuWithReadAccessRootLevel(mobileSelectionMode)
        }else{
        this.sharedWithMeMultipleSharedFileContextMenuWithReadAccess(mobileSelectionMode)
        }
      }
    }
  }

  sharedByMeMultipleSharedFileContextMenuWithEditAccess(mobileSelectionMode){
    var classRef = this.universalService;
    if(mobileSelectionMode){
      if(classRef.openMoreOptions){ //expanded mode
        classRef.topMenuOptions  = this.sharedByMe["EditAccess"]["selectionModeOn"]["multipleFile"]["inExpandMode"]["topMenu"];
        classRef.middleMenuOptionsMobile = [];
        classRef.bottomMenuOptionsMobile = this.sharedByMe["EditAccess"]["selectionModeOn"]["multipleFile"]["inExpandMode"]["bottomMenu"]
      }else{
        classRef.topMenuOptions  = this.sharedByMe["EditAccess"]["selectionModeOn"]["multipleFile"]["collapsedMode"]["topMenu"];
        classRef.middleMenuOptionsMobile = [];
        classRef.bottomMenuOptionsMobile = [];
      }
    }else{
     
    }
  }

  sharedByMeMultipleSharedFileContextMenuWithEditAccessRootLevel(mobileSelectionMode){
    var classRef = this.universalService;
    if(mobileSelectionMode){
      if(classRef.openMoreOptions){ //expanded mode
        classRef.topMenuOptions  = this.sharedByMe["EditAccess"]["selectionModeOn"]["rootLevelOptions"]["multipleFile"]["inExpandMode"]["topMenu"];
        classRef.middleMenuOptionsMobile = [];
        classRef.bottomMenuOptionsMobile = this.sharedByMe["EditAccess"]["selectionModeOn"]["rootLevelOptions"]["multipleFile"]["inExpandMode"]["bottomMenu"]
      }else{
        classRef.topMenuOptions  = this.sharedByMe["EditAccess"]["selectionModeOn"]["rootLevelOptions"]["multipleFile"]["collapsedMode"]["topMenu"];
        classRef.middleMenuOptionsMobile = [];
        classRef.bottomMenuOptionsMobile = [];
      }
    }
  }

  sharedWithMeMultipleSharedFileContextMenuWithEditAccess(mobileSelectionMode){
    var classRef = this.universalService;
    if(mobileSelectionMode){
      if(classRef.openMoreOptions){ //expanded mode
        classRef.topMenuOptions  = this.sharedWithMe["EditAccess"]["selectionModeOn"]["multipleFile"]["inExpandMode"]["topMenu"];
        classRef.middleMenuOptionsMobile = [];
        classRef.bottomMenuOptionsMobile = this.sharedWithMe["EditAccess"]["selectionModeOn"]["multipleFile"]["inExpandMode"]["bottomMenu"]
      }else{
        classRef.topMenuOptions  = this.sharedWithMe["EditAccess"]["selectionModeOn"]["multipleFile"]["collapsedMode"]["topMenu"];
        classRef.middleMenuOptionsMobile = [];
        classRef.bottomMenuOptionsMobile = [];
      }
    }else{
     
    }
  }

  sharedWithMeMultipleSharedFileContextMenuWithEditAccessRootLevel(mobileSelectionMode){
    var classRef = this.universalService;
    if(mobileSelectionMode){
      if(classRef.openMoreOptions){ //expanded mode
        classRef.topMenuOptions  = this.sharedWithMe["EditAccess"]["rootLevelOptions"]["selectionModeOn"]["multipleFile"]["inExpandMode"]["topMenu"];
        classRef.middleMenuOptionsMobile = [];
        classRef.bottomMenuOptionsMobile = this.sharedWithMe["EditAccess"]["rootLevelOptions"]["selectionModeOn"]["multipleFile"]["inExpandMode"]["bottomMenu"]
      }else{
        classRef.topMenuOptions  = this.sharedWithMe["EditAccess"]["rootLevelOptions"]["selectionModeOn"]["multipleFile"]["collapsedMode"]["topMenu"];
        classRef.middleMenuOptionsMobile = [];
        classRef.bottomMenuOptionsMobile = [];
      }
    }else{
     
    }
  }

  sharedWithMeMultipleSharedFileContextMenuWithReadAccess(mobileSelectionMode){
    var classRef = this.universalService;
    if(mobileSelectionMode){
      if(classRef.openMoreOptions){ //expanded mode
        classRef.topMenuOptions  = this.sharedWithMe["ReadAccess"]["selectionModeOn"]["multipleFile"]["inExpandMode"]["topMenu"];
        classRef.middleMenuOptionsMobile = [];
        classRef.bottomMenuOptionsMobile = this.sharedWithMe["ReadAccess"]["selectionModeOn"]['multipleFile']['inExpandMode']["bottomMenu"];
      }else{
        classRef.topMenuOptions  = this.sharedWithMe["ReadAccess"]["selectionModeOn"]["multipleFile"]["collapsedMode"]["topMenu"];
        classRef.middleMenuOptionsMobile = [];
        classRef.bottomMenuOptionsMobile = [];
      }
    }else{
     
    }
  }

  sharedWithMeMultipleSharedFileContextMenuWithReadAccessRootLevel(mobileSelectionMode){
    var classRef = this.universalService;
    if(mobileSelectionMode){
      if(classRef.openMoreOptions){ //expanded mode
        classRef.topMenuOptions  = this.sharedWithMe["ReadAccess"]["rootLevelOptions"]["selectionModeOn"]["multipleFile"]["inExpandMode"]["topMenu"];
        classRef.middleMenuOptionsMobile = [];
        classRef.bottomMenuOptionsMobile = this.sharedWithMe["ReadAccess"]["rootLevelOptions"]["selectionModeOn"]['multipleFile']['inExpandMode']["bottomMenu"];
      }else{
        classRef.topMenuOptions  = this.sharedWithMe["ReadAccess"]["rootLevelOptions"]["selectionModeOn"]["multipleFile"]["collapsedMode"]["topMenu"];
        classRef.middleMenuOptionsMobile = [];
        classRef.bottomMenuOptionsMobile = [];
      }
    }else{
     
    }
  }


  getContextMenuForMultipleFilesJioPhoneCallAI(mobileSelectionMode){
    let classRef = this.universalService;
    if(mobileSelectionMode){ // selection mode is on
      if(classRef.openMoreOptions){ // if more options is open
        classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["Jio_Phone_Call_AI"]["fileMenu"]["inExpandMode"]["topMenu"];
        classRef.bottomMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["Jio_Phone_Call_AI"]["fileMenu"]["inExpandMode"]["bottomMenu"];
        classRef.middleMenuOptionsMobile = [];
      }else{ // if more options is close
        classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["multipleFile"]["Jio_Phone_Call_AI"]["fileMenu"]["topMenu"];
        classRef.bottomMenuOptionsMobile = [];
        classRef.middleMenuOptionsMobile = [];
      }
    }
  }

  getContextMenuForMultipleFoldersJioPhoneCallAI(mobileSelectionMode){
    let classRef = this.universalService;
    if(mobileSelectionMode){ // selection mode is on
      if(classRef.openMoreOptions){ // if more options is open
        classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["Jio_Phone_Call_AI"]["folderMenu"]["inExpandMode"]["topMenu"];
        classRef.bottomMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOn"]["multipleFile"]["Jio_Phone_Call_AI"]["folderMenu"]["inExpandMode"]["bottomMenu"];
        classRef.middleMenuOptionsMobile = [];
      }else{ // if more options is close
        classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["multipleFile"]["Jio_Phone_Call_AI"]["folderMenu"]["topMenu"];
        classRef.bottomMenuOptionsMobile = [];
        classRef.middleMenuOptionsMobile = [];
      }
    }
  }

  getContextMenuForSingleFileJioPhoneCallAI(selectionModeOn){
    let classRef = this.universalService;
    if(selectionModeOn || classRef.showPreview){ // selection mode is on
      if(classRef.openMoreOptions){ // if more options is open
        classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["Jio_Phone_Call_AI"]["fileMenu"]["inExpandMode"]["topMenu"];
        classRef.bottomMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["Jio_Phone_Call_AI"]["fileMenu"]["inExpandMode"]["bottomMenu"];
        classRef.middleMenuOptionsMobile = [];
      }else{ // if more options is close
        classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["singleFile"]["Jio_Phone_Call_AI"]["fileMenu"]["topMenu"];
        classRef.bottomMenuOptionsMobile = [];
        classRef.middleMenuOptionsMobile = [];
      }
    }else{ //selection mode if Off
      classRef.topMenuOptions  = [];
      classRef.middleMenuOptionsMobile = [];
      classRef.bottomMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOff"]["Jio_Phone_Call_AI"]["fileMenu"]["bottomMenu"];
    }
  }

  getContextMenuForSingleFolderJioPhoneCallAI(selectionModeOn){
    let classRef = this.universalService;
    if(selectionModeOn){ // selection mode is on
      if(classRef.openMoreOptions){ // if more options is open
        classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["Jio_Phone_Call_AI"]["folderMenu"]["inExpandMode"]["topMenu"];
        classRef.bottomMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["Jio_Phone_Call_AI"]["folderMenu"]["inExpandMode"]["bottomMenu"];
        classRef.middleMenuOptionsMobile = [];
      }else{ // if more options is close
        classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["singleFile"]["Jio_Phone_Call_AI"]["folderMenu"]["topMenu"];
        classRef.middleMenuOptionsMobile = [];
        classRef.bottomMenuOptionsMobile = [];
      }
    }else{ //selection mode if Off
      classRef.topMenuOptions  = [];
      classRef.middleMenuOptionsMobile = [];
      classRef.bottomMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOff"]["Jio_Phone_Call_AI"]["folderMenu"]["bottomMenu"];
    }
  }
  

  getTFRoleCodeDetail(code) {
    var roleCode = "viewer";
    if(code == "O"){
      roleCode = "owner";
    } else if(code == "E"){
      roleCode = "editor";
    }
    return roleCode
  }

  fetchJSONContents(){
    var self = this;
    this.http.get(ENV_CONFIG.jsonUrls.topMenuMobile).subscribe(
      suc=>{
        self.mobileTopMenu = suc;
      }
    ) 

    this.http.get(ENV_CONFIG.jsonUrls.favouritesAlbumsMobile).subscribe(
      suc=>{
        self.favoriteMenu = suc;
      }
    ) 

    this.http.get(ENV_CONFIG.jsonUrls.sharedByMeMobile).subscribe(
      suc=>{
        self.sharedByMe = suc;
      }
    ) 

    this.http.get(ENV_CONFIG.jsonUrls.sharedWithMeMobile).subscribe(
      suc=>{
        self.sharedWithMe = suc;
      }
    )

    this.http.get(ENV_CONFIG.jsonUrls.officeForWeb).subscribe(
      suc=>{
        self.officeForWeb = suc;
      }
    )
  }

  checkIfOpenWithOfficeForWebOption(file){ 
    var foundInMoreOption = this.universalService.middleMenuOptionsMobile.find(opt=>opt["menuItem"] == "Open with");
    var indexInMoreOptions = this.universalService.middleMenuOptionsMobile.indexOf(foundInMoreOption);
    if(foundInMoreOption){
      this.universalService.middleMenuOptionsMobile.splice(indexInMoreOptions,1);
    }
     
    if(file["format"] != 'image' && file["format"] != 'audio' && file["format"] != 'video'){
      if((file["OfficeForWebSupported"] && this.universalService.MSOfficeSupportedInModule && ENV_CONSTANTS["constants"]["enableOfficeForWebPreview"]) || (file["OfficeForWebSupported"] && file["previewFromUpload"])){
        this.universalService.middleMenuOptionsMobile.unshift(this.universalService.topMenuMobile_MainRepo["previewTypes"])
      }else{
        if(!this.universalService.showPreview){
          this.universalService.middleMenuOptionsMobile.unshift(this.universalService.topMenuMobile_MainRepo["previewTypes"])
        }
      }
    }
  }


  addEditImageOptionIfImageFileIsSelected(file){ 
    var foundInMoreOption = this.universalService.middleMenuOptionsMobile.find(opt=>opt["menuItem"] == "Edit Image");
    var indexInMoreOptions = this.universalService.middleMenuOptionsMobile.indexOf(foundInMoreOption);
    if(foundInMoreOption){
      this.universalService.middleMenuOptionsMobile.splice(indexInMoreOptions,1);
    }
     
    if(file["mimeType"] == 'image' && this.universalService.allowPhotoEditInViewBasedOnAccessRights && this.universalService.photoEditSupportedInModule){
      let isExtSupportedForPhotoEdit = ENV_CONFIG["photoEditSupportedExtensions"].some(obj=> {
        return (file["extension"].toLowerCase()).includes(obj);
      })
      if(isExtSupportedForPhotoEdit){
        this.universalService.middleMenuOptionsMobile.unshift(this.universalService.topMenuMobile_MainRepo["EDIT_IMAGE_OPTION"])
      }
    }
  }

  decideMoreOptionsOnSubMenu(file,type){
    var classRef = this.universalService;
    classRef.moreOptionsSubMenu = [];
    if(type == "openPreviewOptions"){
      var msDocption;
      if((file["OfficeForWebSupported"] && this.universalService.MSOfficeSupportedInModule && ENV_CONSTANTS["constants"]["enableOfficeForWebPreview"]) || (file["OfficeForWebSupported"] && file["previewFromUpload"])){
        var formatType = ""
        if(this.officeForWeb[file.format]){
          formatType = file.format;
        }else{
          formatType = "unknown";
        }
        msDocption = this.officeForWeb[formatType];
        classRef.moreOptionsSubMenu.push(msDocption)
      }
      if(!this.universalService.showPreview){
        classRef.moreOptionsSubMenu.push(this.universalService.topMenuMobile_MainRepo["previewOptions"]);
      }
    }
  }


  checkIfManageVersionsIsTobeSupported(file){
    var classRef = this.universalService;
    var foundManageVersionsOption = classRef.bottomMenuOptionsMobile.find(item => item["menuItem"] == "Manage Versions");
    if (foundManageVersionsOption) {
      var indx = classRef.bottomMenuOptionsMobile.indexOf(foundManageVersionsOption);
      classRef.bottomMenuOptionsMobile.splice(indx, 1);
    }

    if ((this.universalService.manageVersionsSupportedInModule && ENV_CONSTANTS["constants"]["enableManageVersions"]) || (file["versioningSupported"] && file["previewFromUpload"])) {
      if (file["format"] != "image" && file["format"] != "audio" && file["format"] != "video") {
        classRef.bottomMenuOptionsMobile.push(this.mobileTopMenu["MANAGE_VERSION_OPTION"])
      }
    }
  }

  checkIfPrivateFolderOptionToShow() {
    var classRef = this.universalService;
    var userData = this.localStorageSvc.getUserData(true);
    if(userData == undefined) return;
    if(userData["privateFolder"] && userData["privateFolder"]["allowPPF"] != "Y" && userData["privateFolder"]["isPPFEnabled"] != "Y") { //If private folder not enables, hide repo to PF move option
      var topfound = classRef.bottomMenuOptionsMobile.find(k => k["onClick"] == "moveToPrivateFolder")
      if(topfound){
        var index = classRef.bottomMenuOptionsMobile.indexOf(topfound)
        classRef.bottomMenuOptionsMobile.splice(index,1)
      }
    }
  }
  removePrivateFolderOption(){
    var classRef = this.universalService;
      
    if(classRef.selectedNodes.length > 0 && !(this.userData && this.userData["privateFolder"] && this.userData["privateFolder"]["isPPFEnabled"] == "Y" && this.userData["privateFolder"]["allowPPF"] == "Y")){
      var foundMoveToPPFOption = classRef.bottomMenuOptionsMobile.find(item => item["menuItem"] == "Move to Private Folder");
      if (foundMoveToPPFOption) {
        var indx = classRef.bottomMenuOptionsMobile.indexOf(foundMoveToPPFOption);
        classRef.bottomMenuOptionsMobile.splice(indx, 1);
      }

      var foundMoveToPPFOptionTop = classRef.topMenuOptions.find(item => item["menuItem"] == "Move to Private Folder");
      if (foundMoveToPPFOptionTop) {
        var indx = classRef.topMenuOptions.indexOf(foundMoveToPPFOptionTop);
        classRef.topMenuOptions.splice(indx, 1);
      }
    }
  }

  checkIfShowLocationOption(){
    var classRef = this.universalService;
    var foundShowLocationOption = classRef.bottomMenuOptionsMobile.find(item => item["menuItem"] == "Show Location");
    if (foundShowLocationOption) {
      var indx = classRef.bottomMenuOptionsMobile.indexOf(foundShowLocationOption);
      classRef.bottomMenuOptionsMobile.splice(indx, 1);
    }
    if((this.router.url.includes('/search') || this.universalService.isPreviewOpenFromSearchDropdown) && this.universalService.selectedNodes.length == 1) { // adding show location option when user is on search results page
        var foundFileLocationOptionContextMenu = classRef.bottomMenuOptionsMobile.find(item=> item["menuItem"] == "Show Location");
        if(!foundFileLocationOptionContextMenu){
          classRef.bottomMenuOptionsMobile.splice(1,0,classRef.topMenuMobile_MainRepo["FILE_LOCATION_OPTION"]);
        }
    }
  }


  getContextMenuOptionsForMemory(){
    var classRef = this.universalService;
    var currentFile = this.universalService.selectedFile

    if(classRef.openMoreOptions){ // if more options is open
      classRef.topMenuOptions = classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["fileMenu"]["inExpandMode"]["MEMORY"]["topMenu"]
      classRef.middleMenuOptionsMobile = currentFile["isFavorite"] ? classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["fileMenu"]["inExpandMode"]["MEMORY"]["middleMenu"]["unSetFavorite"]:classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["fileMenu"]["inExpandMode"]["MEMORY"]["middleMenu"]["setFavorite"];
      classRef.bottomMenuOptionsMobile = classRef.topMenuMobile_MainRepo["selectionModeOn"]["singleFile"]["fileMenu"]["inExpandMode"]["MEMORY"]["bottomMenu"];
    }else{ // if more options is closed
      classRef.topMenuOptions = currentFile["isFavorite"] ? classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["singleFile"]["fileMenu"]["memory_topMenu_Favorited"] : classRef.topMenuMobile_MainRepo["selectionModeOn"]["collapsedMode"]["singleFile"]["fileMenu"]["memory_topMenu"];
      classRef.middleMenuOptionsMobile = []
      classRef.bottomMenuOptionsMobile = []
    }
    this.getDefaultIconContentForObjects()
  }


  checkIfUploafFromPreviewAndRemoveUnecessaryOptions(file,topMenuOptions,middleMenuOptionsMobile,bottomMenuOptionsMobile){
    if(!file || !file["previewFromUpload"]) return
    this.removeUnnecessaryOptionsFromMiddleMenuOptions(middleMenuOptionsMobile);
    this.removeUnnecessaryOptionsFromBottomMenuOptions(bottomMenuOptionsMobile);
    this.removeUnnecessaryOptionsFromTopmenuOptions(topMenuOptions);
  }


  removeUnnecessaryOptionsFromMiddleMenuOptions(middleMenuOptionsMobile){
    let options = [];
    middleMenuOptionsMobile.map((option)=>{
      if(!this.universalService.OPERATIONS_WHICH_NEED_UI_UPDATE.includes(option["menuItem"])){
        options.push(option);
      }
    })
    this.universalService.middleMenuOptionsMobile = options;
  }

  removeUnnecessaryOptionsFromBottomMenuOptions(bottomMenuOptionsMobile){
    let options = [];
    bottomMenuOptionsMobile.map((option)=>{
      if(!this.universalService.OPERATIONS_WHICH_NEED_UI_UPDATE.includes(option["menuItem"])){
        options.push(option);
      }
    })
    this.universalService.bottomMenuOptionsMobile = options;
  }

  removeUnnecessaryOptionsFromTopmenuOptions(topMenuOptions){
    let options = []
    topMenuOptions.map((option)=>{
      if(!this.universalService.OPERATIONS_WHICH_NEED_UI_UPDATE.includes(option["menuItem"])){
        options.push(option);
      }
    })

    this.universalService.topMenuOptions = options;
  }

  removeDownloadOptionFromMenuWhenTheObjectsAreFromDifferentHierarchies(){
    // this function is added specific to search pages as the search results come from different hierarchies and bulk download from server has some limitation on downloading files from different hierarchies
    if(this.router.url.includes("/search") && !this.router.url.includes("/tf")) {
      var findDownloadInBottomMenuOptions = this.universalService.bottomMenuOptionsMobile.find(opt=>opt["menuItem"] == "Download");
      var findDownloadIntopMenuOptions = this.universalService.topMenuOptions.find(opt=>opt["menuItem"] == "Download");
      if(findDownloadInBottomMenuOptions){
        let index = this.universalService.bottomMenuOptionsMobile.indexOf(findDownloadInBottomMenuOptions);
        if(index >= 0){
          this.universalService.bottomMenuOptionsMobile[index]["isDisabled"] = "disabled"
        }
      }

      if(findDownloadIntopMenuOptions){
        let index = this.universalService.topMenuOptions.indexOf(findDownloadIntopMenuOptions);
        if(index >= 0){
          this.universalService.topMenuOptions[index]["isDisabled"] = "disabled"
        }
      }
    }
  }

  removeShareOptionFromMenuWhenMultipleObject(){
    if(this.router.url.includes("/search") && !this.router.url.includes("/tf")) {
      var findShareIntopMenuOptions = this.universalService.topMenuOptions.find(opt=>opt["menuItem"] == "Share");
      if(findShareIntopMenuOptions){
        let index = this.universalService.topMenuOptions.indexOf(findShareIntopMenuOptions);
        if(index >= 0){
          this.universalService.topMenuOptions[index]["isDisabled"] = "disabled"
        }
      }
    }
  }
  
}
